
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("cmkWO", function(module, exports) {
/**
 * @generated SignedSource<<b387d58755674457ae4f39adf063ec37>>
 * @relayHash 4d36c161a002817ebf0a774bd870c3f0
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID e774a160f409825c4d6c3237444559164a7757efd676ad8ac90163b199ff341e
const $52181a874b01b0e6$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "spaceKey"
                }
            ],
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "space",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "concreteType": "LookAndFeel",
                    "kind": "LinkedField",
                    "name": "lookAndFeel",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "ContentLookAndFeel",
                            "kind": "LinkedField",
                            "name": "content",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "ScreenLookAndFeel",
                                    "kind": "LinkedField",
                                    "name": "screen",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "background"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "backgroundColor"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "backgroundImage"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "backgroundPosition"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "backgroundSize"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "backgroundRepeat"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "backgroundOrigin"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "backgroundClip"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "backgroundAttachment"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "backgroundBlendMode"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "MainLayoutQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "MainLayoutQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "4d36c161a002817ebf0a774bd870c3f0",
            "id": "e774a160f409825c4d6c3237444559164a7757efd676ad8ac90163b199ff341e",
            "metadata": {},
            "name": "MainLayoutQuery",
            "operationKind": "query",
            "text": "query MainLayoutQuery($spaceKey:String!){space(key:$spaceKey){id,lookAndFeel{content{screen{background,backgroundColor,backgroundImage,backgroundPosition,backgroundSize,backgroundRepeat,backgroundOrigin,backgroundClip,backgroundAttachment,backgroundBlendMode}}}}}"
        }
    };
}();
$52181a874b01b0e6$var$node.hash = "de3e636b8d3cf59cd103bdc7552ea849";
var $52181a874b01b0e6$export$2e2bcd8739ae039 = $52181a874b01b0e6$var$node;



var $cozmU = parcelRequire("cozmU");


var $jMyy4 = parcelRequire("jMyy4");


var $kVysQ = parcelRequire("kVysQ");


var $6CEg5 = parcelRequire("6CEg5");


var $7Sm4c = parcelRequire("7Sm4c");


var $b3j2Y = parcelRequire("b3j2Y");


var $1uFM6 = parcelRequire("1uFM6");


var $f9jv7 = parcelRequire("f9jv7");


var $5vi32 = parcelRequire("5vi32");


var $3jwuS = parcelRequire("3jwuS");


var $lJlG6 = parcelRequire("lJlG6");

/* MainLayoutComponent.tsx generated by @compiled/babel-plugin v3.0.2 */ 



var $hekY6 = parcelRequire("hekY6");


var $kNIYN = parcelRequire("kNIYN");


var $hrAmX = parcelRequire("hrAmX");


var $3IBnw = parcelRequire("3IBnw");


var $4PPzL = parcelRequire("4PPzL");


var $eSLr0 = parcelRequire("eSLr0");


var $5ZPtT = parcelRequire("5ZPtT");

/**
 * @generated SignedSource<<aee3d452e700222c207ed3413b38e9d4>>
 * @relayHash b1c5bff520163b91e48e77e975abc312
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 808594c60ce4834378741a27b78d1f8617da8c6d03a72504d9df4572dc06ca47
const $4a82a81af9c5e51c$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "spaceKey"
                }
            ],
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "space",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "concreteType": "Theme",
                    "kind": "LinkedField",
                    "name": "theme",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "themeKey"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useATLGeneralWebPanelObserverSpaceThemeQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useATLGeneralWebPanelObserverSpaceThemeQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "b1c5bff520163b91e48e77e975abc312",
            "id": "808594c60ce4834378741a27b78d1f8617da8c6d03a72504d9df4572dc06ca47",
            "metadata": {},
            "name": "useATLGeneralWebPanelObserverSpaceThemeQuery",
            "operationKind": "query",
            "text": "query useATLGeneralWebPanelObserverSpaceThemeQuery($spaceKey:String){space(key:$spaceKey){id,theme{themeKey}}}"
        }
    };
}();
$4a82a81af9c5e51c$var$node.hash = "5414d0003b526de29b97ae12c29148ab";
var $4a82a81af9c5e51c$export$2e2bcd8739ae039 = $4a82a81af9c5e51c$var$node;






var $55fM8 = parcelRequire("55fM8");








var $ep3mz = parcelRequire("ep3mz");


var $cEgMD = parcelRequire("cEgMD");


var $dPJCf = parcelRequire("dPJCf");


var $1NBp8 = parcelRequire("1NBp8");

const $edacfc52aca854e0$export$58b315702afd1f24 = (contentType)=>{
    return contentType === 'page' || contentType === 'blogpost';
};



var $1P7Cq = parcelRequire("1P7Cq");


var $6mKj3 = parcelRequire("6mKj3");


var $1xpoY = parcelRequire("1xpoY");





var $dS3n9 = parcelRequire("dS3n9");

/**
 * Parse connect app scripts width and height, and preset connect apps dimention
 * before iframe gets injected, to avoid connect apps iframe causing layout shift
 * up and down multiple times
 *
 * Return total height of connect apps rendered in a location
 * @param container - The HTMLElement contains connect apps
 * @returns {number | undefined} - Returns total height of connect apps rendered in the container
 */ const $bd143360dd0cf955$export$a25046a8b24b3fc6 = (container, isEarlyInitIframe = false)=>{
    // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    if (!document || !container) return;
    // Get all connect-app scripts at container, there can be multiple ones
    const allScripts = container.querySelectorAll('script.ap-iframe-body-script');
    if (!allScripts || allScripts.length === 0) return;
    // Total height of connect-app wrapper
    let totalHeight = 0;
    const parsePx = (matchedVal)=>{
        // Parse % or px
        let addPx = '';
        if (matchedVal.indexOf('%') === -1 && matchedVal.indexOf('px') === -1) addPx = 'px';
        return addPx;
    };
    allScripts.forEach((iframeScript)=>{
        // Get connect-app script html
        const scriptHtml = iframeScript?.innerHTML || '';
        if (scriptHtml) {
            const scriptWrapper = iframeScript.parentNode;
            // Extract connect-app height
            const matchedHeight = scriptHtml.match(/"h":\s*"(\d+(?:%|px)?)"/);
            const matchedHeightVal = matchedHeight?.[1];
            if (matchedHeightVal) {
                const matchedInt = parseInt(matchedHeightVal);
                // Add this connect-app height to total height
                if (typeof matchedInt === 'number') totalHeight += matchedInt;
                // Preset connect-app wrapper height before iframe is injected
                // NOTE: We don't want to set width or height, in case iframe is early initialized.
                if (!isEarlyInitIframe && scriptWrapper) scriptWrapper.style.height = matchedHeightVal + parsePx(matchedHeightVal);
            } else // If unable to extract height value, default to 0 during iframe loading to prevent jumping,
            // this will eventually be removed after connect apps are fully loaded.
            if (!isEarlyInitIframe) scriptWrapper.style.height = '0px';
            // Extract connect-app width
            const matchedWidth = scriptHtml.match(/"w":\s*"(\d+(?:%|px)?)"/);
            const matchedWidthVal = matchedWidth?.[1];
            if (matchedWidthVal) // Preset connect-app wrapper height before iframe is injected
            // NOTE: We don't want to set width or height, in case iframe is early initialized.
            {
                if (!isEarlyInitIframe && scriptWrapper) scriptWrapper.style.width = matchedWidthVal + parsePx(matchedWidthVal);
            }
        }
    });
    return totalHeight;
};
const $bd143360dd0cf955$export$a2ff9656ed51a40a = (container, timeout = false)=>{
    // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    if (!document || !container) return;
    const appStatus = [];
    const allScripts = container.querySelectorAll('script.ap-iframe-body-script');
    if (!allScripts || allScripts.length === 0) return;
    // Remove each connect-app wrapper preset width and height after iframe loaded
    allScripts.forEach((iframeScript)=>{
        // Get connect-app parent
        const scriptWrapper = iframeScript.parentNode;
        const iframeLoaded = !!scriptWrapper.querySelector('iframe');
        const statusIndicator = scriptWrapper.querySelector('.ap-status-indicator');
        const timeoutIndicator = scriptWrapper.querySelector('.ap-load-timeout');
        const statusIndicatorHidden = statusIndicator?.style.display === 'none';
        // Check connect app loading status
        const isAppLoaded = iframeLoaded && (statusIndicatorHidden || timeoutIndicator);
        // Store each iframe's loading status
        appStatus.push(isAppLoaded);
        // If iframe is loaded, remove preset width and height
        if (isAppLoaded || timeout) {
            if (scriptWrapper?.style.height) scriptWrapper.style.height = '';
            if (scriptWrapper?.style.width) scriptWrapper.style.width = '';
        }
    });
    // Return if all connect apps are loaded
    return appStatus.every((status)=>status === true);
};
const $bd143360dd0cf955$export$e36afaf5515aa43 = 10000;


const $9739cc17e95eb22c$export$8610b0674aff537e = (isViewPage, isEdit)=>{
    const [{ contentId: contentId, spaceKey: spaceKey, contentType: contentType }] = (0, $ep3mz.usePageState)();
    const { panels: panels } = (0, $dS3n9.useWebPanelLocation)({
        location: (0, $eSLr0.ATL_GENERAL),
        fetchPolicy: 'cache-first',
        spaceKey: spaceKey,
        contentId: contentId
    });
    const fixedATLGeneralWebPanelRef = (0, $cozmU.useRef)(null);
    const allAppsLoaded = (0, $cozmU.useRef)(false);
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const isCompanyHub = (0, $cEgMD.isCompanyHubSpaceKey)(spaceKey);
    const routeDataRef = (0, $dPJCf.useRouteDataRef)();
    const renderServerPlaceholder = (0, $1P7Cq.useIsSSROrHydrating)();
    const presetTimeoutConfig = (0, $1xpoY.default).getNumber('confluence_webpanel_preset_dimension_time', 0);
    const heightUpdateThreshold = (0, $1xpoY.default).getNumber('confluence_webpanel_update_height_threshold', 0);
    // For Nav 3, we expand atl.general panel to full width when the side nav is not present. This is the case for
    // company hub and when url has mode=global, such as on custom homepage
    // For Nav 4, the side nav is always present, so we have an additional check on isNav4Enabled in FixedWebPanelWrapper
    const isFullWidth = (0, $cEgMD.isCompanyHubSpaceKey)(spaceKey) || routeDataRef.current?.queryParams?.mode === 'global';
    const shouldShowATLGeneralWebPanel = panels.length > 0;
    // Determines if panels should not display a UI element and only allow for the support of scripts and analytics
    const shouldHidePanels = !(0, $edacfc52aca854e0$export$58b315702afd1f24)(contentType) && contentType;
    // Fixed behavior should be consistent for all pages as the same header is used for live / edit as well
    const canFixOnEditOrLivePage = isViewPage || isEdit || isLivePage;
    // If the other conditions for a fixed web panel are true, check whether the space is themed
    // The web panel should not be fixed for themed spaces since they do not have a fixed page header
    const canFixATLGeneralWebPanel = shouldShowATLGeneralWebPanel && canFixOnEditOrLivePage;
    const { data: data } = (0, $jMyy4.useQueryInterop)((0, $4a82a81af9c5e51c$export$2e2bcd8739ae039), {
        skip: !canFixATLGeneralWebPanel,
        variables: {
            spaceKey: spaceKey
        },
        __callerPackage__: "web-panel-location"
    });
    const isATLGeneralWebPanelFixed = canFixATLGeneralWebPanel && data?.space?.theme === null;
    const isAdvancedSearch = routeDataRef.current?.routeName === (0, $1NBp8.ADVANCED_SEARCH).name;
    // ResizeObserver is needed because the height of web panel items can change at any time
    const resizeObserver = (0, $cozmU.useMemo)(()=>{
        if (!renderServerPlaceholder) {
            const callback = (0, (/*@__PURE__*/$parcel$interopDefault($55fM8)))(([entry])=>{
                if (entry) {
                    // Remove each connect app preset dimension until all apps are loaded
                    if (!allAppsLoaded.current) allAppsLoaded.current = !!(0, $bd143360dd0cf955$export$a2ff9656ed51a40a)(entry.target);
                    // Only reset container height after all connect apps are loaded,
                    // to prevent layout shift jumping up and down
                    if (allAppsLoaded.current) {
                        let newHeight = entry.target.clientHeight;
                        if (Boolean(window.__SSR_RENDERED__) && heightUpdateThreshold > 0 && !isAdvancedSearch) {
                            const initialHeight = window['__ATL_GENERAL_WEBPANEL_INITIAL_HEIGHT__'] || 0;
                            const currentHeight = entry.target.clientHeight || 0;
                            // Ignore height changes that are less than the threshold
                            if (Math.abs(currentHeight - initialHeight) <= heightUpdateThreshold) newHeight = initialHeight;
                        }
                        // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
                        document.documentElement.style.setProperty('--atl-general-webpanel-height', `${newHeight}px`);
                        const detail = (0, $6mKj3.expVal)('confluence_p2m_style_recalc_and_expand_joint_exp', 'isEnabled', false) ? {
                            detail: {
                                height: newHeight
                            }
                        } : undefined;
                        // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
                        document.dispatchEvent(new CustomEvent('atlGeneralWebPanelHeightUpdated', detail));
                    }
                }
            }, 100);
            return new ResizeObserver(callback);
        }
    }, [
        renderServerPlaceholder,
        heightUpdateThreshold,
        isAdvancedSearch
    ]);
    (0, $cozmU.useLayoutEffect)(()=>{
        const fixedATLGeneralWebPanel = fixedATLGeneralWebPanelRef.current;
        let appLoadTimeoutId;
        let presetTimeoutId;
        if (!renderServerPlaceholder && isATLGeneralWebPanelFixed && fixedATLGeneralWebPanel) {
            // Handle content types that have web panel hidden, some content types have web panel hidden,
            // so it don't need to preset wrapper dimension.
            if (shouldHidePanels) {
                document.documentElement.style.setProperty('--atl-general-webpanel-height', `0px`);
                const detail_0 = (0, $6mKj3.expVal)('confluence_p2m_style_recalc_and_expand_joint_exp', 'isEnabled', false) ? {
                    detail: {
                        height: 0
                    }
                } : undefined;
                document.dispatchEvent(new CustomEvent('atlGeneralWebPanelHeightUpdated', detail_0));
            } else {
                const totalHeight = (0, $bd143360dd0cf955$export$a25046a8b24b3fc6)(fixedATLGeneralWebPanel);
                if (totalHeight) {
                    document.documentElement.style.setProperty('--atl-general-webpanel-height', `${totalHeight}px`);
                    const detail_1 = (0, $6mKj3.expVal)('confluence_p2m_style_recalc_and_expand_joint_exp', 'isEnabled', false) ? {
                        detail: {
                            height: totalHeight
                        }
                    } : undefined;
                    document.dispatchEvent(new CustomEvent('atlGeneralWebPanelHeightUpdated', detail_1));
                }
                // If after max wait time, connect apps are still not loaded, then remove preset dimensions
                appLoadTimeoutId = setTimeout(()=>{
                    if (!allAppsLoaded.current) {
                        (0, $bd143360dd0cf955$export$a2ff9656ed51a40a)(fixedATLGeneralWebPanel, true);
                        allAppsLoaded.current = true;
                        const connectAppsWrapperContainer = fixedATLGeneralWebPanel;
                        const containerHeight = connectAppsWrapperContainer?.clientHeight || 0;
                        document.documentElement.style.setProperty('--atl-general-webpanel-height', `${containerHeight}px`);
                        const detail_2 = (0, $6mKj3.expVal)('confluence_p2m_style_recalc_and_expand_joint_exp', 'isEnabled', false) ? {
                            detail: {
                                height: containerHeight
                            }
                        } : undefined;
                        document.dispatchEvent(new CustomEvent('atlGeneralWebPanelHeightUpdated', detail_2));
                    }
                }, (0, $bd143360dd0cf955$export$e36afaf5515aa43));
            }
        }
        if (isATLGeneralWebPanelFixed) {
            // If the page is SSR rendered and the initial height is set,
            // preserve the initial height a little bit longer until apps height become stable
            if (Boolean(window.__SSR_RENDERED__) && !isAdvancedSearch) presetTimeoutId = setTimeout(()=>{
                fixedATLGeneralWebPanel && resizeObserver?.observe(fixedATLGeneralWebPanel);
            }, presetTimeoutConfig);
            else fixedATLGeneralWebPanel && resizeObserver?.observe(fixedATLGeneralWebPanel);
        }
        return ()=>{
            if (isATLGeneralWebPanelFixed) fixedATLGeneralWebPanel && resizeObserver?.unobserve(fixedATLGeneralWebPanel);
            if (appLoadTimeoutId) clearTimeout(appLoadTimeoutId);
            if (presetTimeoutConfig && presetTimeoutId) clearTimeout(presetTimeoutId);
        };
    }, [
        shouldShowATLGeneralWebPanel,
        isATLGeneralWebPanelFixed,
        resizeObserver,
        renderServerPlaceholder,
        shouldHidePanels,
        presetTimeoutConfig,
        isAdvancedSearch
    ]);
    return {
        shouldShowATLGeneralWebPanel: shouldShowATLGeneralWebPanel,
        isATLGeneralWebPanelFixed: isATLGeneralWebPanelFixed,
        fixedATLGeneralWebPanelRef: fixedATLGeneralWebPanelRef,
        isCompanyHub: isCompanyHub,
        isFullWidth: isFullWidth,
        shouldHidePanels: shouldHidePanels
    };
};



var $9Z1sw = parcelRequire("9Z1sw");








var $gXfti = parcelRequire("gXfti");
























var $bQm3c = parcelRequire("bQm3c");





var $7Ndnw = parcelRequire("7Ndnw");


var $3b6WO = parcelRequire("3b6WO");


var $9gIPO = parcelRequire("9gIPO");

const $062cf5e7a1742c3e$export$a6ca923c8089e1e8 = (isViewPage, isNav4Enabled, isEdit)=>{
    const [{ spaceKey: spaceKey, contentType: contentType, routeName: routeName }] = (0, $ep3mz.usePageState)();
    const routeDataRef = (0, $dPJCf.useRouteDataRef)();
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const renderServerPlaceholder = (0, $1P7Cq.useIsSSROrHydrating)();
    const { extensions: extensions, isSSRResult: isSSRResult } = (0, $3b6WO.useExtensionList)({
        moduleType: (0, $7Ndnw.FORGE_MODULE_PAGE_BANNER)
    });
    // For Nav 3, we expand the banner to full width when the side nav is not present. This is the case for
    // company hub and when url has mode=global, such as on custom homepage.
    // For Nav 4, the side nav is always present - so the banner is never full width)
    const isSideNavPresent = isNav4Enabled || (0, $cEgMD.isCompanyHubSpaceKey)(spaceKey) || routeDataRef.current?.queryParams?.mode === 'global';
    const { isForgePageBannerFixed: isForgePageBannerFixed, fixedForgePageBannerRef: fixedForgePageBannerRef } = $062cf5e7a1742c3e$var$useForgePageBannerObserverHelper(isViewPage, isLivePage, renderServerPlaceholder, extensions, isEdit);
    return {
        mantraNavigationHeight: routeName === (0, $1NBp8.HOME).name || (isViewPage || isEdit || isLivePage) && (0, $edacfc52aca854e0$export$58b315702afd1f24)(contentType) ? (0, $9gIPO.getMantraNavigationHeight)((0, $1xpoY.default).getString('cc_mantra_navigation_tenant_heights', ''), cloudId, extensions) : 0,
        hasPreloadedForgePageBanners: isSSRResult ? extensions.length > 0 : undefined,
        isForgePageBannerFixed: isForgePageBannerFixed,
        fixedForgePageBannerRef: fixedForgePageBannerRef,
        isForgePageBannerFullWidth: isSideNavPresent,
        shouldHideForgePageBanner: contentType && !(0, $edacfc52aca854e0$export$58b315702afd1f24)(contentType)
    };
};
const $062cf5e7a1742c3e$var$useForgePageBannerObserverHelper = (isViewPage, isLivePage, renderServerPlaceholder, extensions, isEdit)=>{
    const fixedForgePageBannerRef = (0, $cozmU.useRef)(null);
    const lastLoggedForgePageBannerHeightRef = (0, $cozmU.useRef)(undefined);
    const isForgePageBannerFixed = isViewPage && !isLivePage && !isEdit && extensions.length > 0; // extensions triggers a re-render
    const resizeObserver = (0, $cozmU.useMemo)(()=>{
        if (!renderServerPlaceholder) return new ResizeObserver((0, (/*@__PURE__*/$parcel$interopDefault($55fM8)))(([entry])=>{
            if (entry) {
                const height = entry.target.clientHeight;
                // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
                document.documentElement.style.setProperty('--forge-page-banner-height', `${height}px`);
                if (lastLoggedForgePageBannerHeightRef.current !== height) {
                    lastLoggedForgePageBannerHeightRef.current = height;
                    (0, $gXfti.addUFOCustomData)({
                        fixedForgePageBannerWrapperHeight: height
                    });
                }
                const detail = (0, $6mKj3.expVal)('confluence_pgxp_p2m_batch_1', 'isEnabled', false) ? {
                    detail: {
                        height: height
                    }
                } : undefined;
                // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
                document.dispatchEvent(new CustomEvent('forgePageBannerHeightUpdated', detail));
            }
        }, 100));
    }, [
        renderServerPlaceholder
    ]);
    (0, $cozmU.useLayoutEffect)(()=>{
        const fixedForgePageBanner = fixedForgePageBannerRef.current;
        if (isForgePageBannerFixed) fixedForgePageBanner && resizeObserver?.observe(fixedForgePageBanner);
        return ()=>{
            fixedForgePageBanner && resizeObserver?.unobserve(fixedForgePageBanner);
        };
    }, [
        isForgePageBannerFixed,
        resizeObserver,
        renderServerPlaceholder
    ]);
    return {
        isForgePageBannerFixed: isForgePageBannerFixed,
        fixedForgePageBannerRef: fixedForgePageBannerRef
    };
};



var $1jwVN = parcelRequire("1jwVN");





var $7zgzO = parcelRequire("7zgzO");

/* ReturnToMobileComponent.tsx generated by @compiled/babel-plugin v3.0.2 */ 






var $kSwu1 = parcelRequire("kSwu1");


var $i1t43 = parcelRequire("i1t43");


var $lzgC6 = parcelRequire("lzgC6");


var $68uaC = parcelRequire("68uaC");


var $8dwdz = parcelRequire("8dwdz");


var $jlIaF = parcelRequire("jlIaF");

function $796a872a5806d472$var$_defineProperty(e, r, t) {
    return (r = $796a872a5806d472$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $796a872a5806d472$var$_toPropertyKey(t) {
    var i = $796a872a5806d472$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $796a872a5806d472$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
const $796a872a5806d472$var$returnLinkContainer = null;
const $796a872a5806d472$export$5945f0cd1996f6fc = (0, $lzgC6.default)()(class ReturnToMobileComponent extends (0, $cozmU.PureComponent) {
    componentDidMount() {
        const { createAnalyticsEvent: createAnalyticsEvent } = this.props;
        const { isSupportedUserAgent: isSupportedUserAgent } = this.state;
        if (isSupportedUserAgent && createAnalyticsEvent) {
            const analyticsData = {
                source: 'mobileWebView',
                action: 'visited',
                actionSubject: 'page'
            };
            createAnalyticsEvent({
                type: 'sendOperationalEvent',
                data: analyticsData
            }).fire();
        }
    }
    isDesktopSwitchRequired() {
        // Port from com.atlassian.confluence.mobile.MobileUtils#isDesktopSwitchRequired
        const { getQueryParams: getQueryParams } = this.props;
        const { desktop: desktop } = getQueryParams();
        return (0, $68uaC.Cookies).get('confluence.mobile.desktop.switch') === 'true' || desktop === 'true';
    }
    render() {
        const { isSupportedUserAgent: isSupportedUserAgent, isDesktopOverride: isDesktopOverride } = this.state; // Only show this if the user is on a mobile device and has explicitly chosen to show desktop
        if (isSupportedUserAgent && isDesktopOverride) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            className: (0, $hekY6.default)([
                "_4FKVYE5zaO _2uo31fDMqu _2fwxA5DIqT"
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
            id: "return-to-mobile.nav.switch.to.mobile.text",
            defaultMessage: "You are viewing the desktop version of Confluence on a mobile supported device."
        }), ' ', /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i1t43.default), {
            href: this.getSwitchToMobileHref(),
            onClick: this.onSwitchClick
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
            id: "return-to-mobile.nav.switch.to.mobile.action",
            defaultMessage: "Switch to Confluence Mobile"
        })));
        return null;
    }
    constructor(...args){
        super(...args);
        $796a872a5806d472$var$_defineProperty(this, "state", {
            isSupportedUserAgent: (0, $8dwdz.isMobileUserAgent)(),
            // If the mobile SPA is handling mobile view, we need to check local storage
            // TODO: Remove the call to isDesktopSwitchRequired once mobile-plugin is dead
            isDesktopOverride: this.isDesktopSwitchRequired() || (0, $8dwdz.isDesktopOverrideActive)()
        });
        $796a872a5806d472$var$_defineProperty(this, "onSwitchClick", (event)=>{
            event.preventDefault();
            const { getQueryParams: getQueryParams, setQueryParams: setQueryParams } = this.props; // If the backend filter has not set a cookie, we need to remove it from local storage (the new way)
            // TODO: Remove the call to isDesktopSwitchRequired once mobile-plugin is dead
            if (!this.isDesktopSwitchRequired()) (0, $8dwdz.deactivateDesktopOverride)();
            else // Otherwise, we need to remove the cookie
            (0, $68uaC.Cookies).remove('confluence.mobile.desktop.switch', {
                path: (0, $jlIaF.CONTEXT_PATH)
            });
            const queryParams = getQueryParams(); // remove the desktop=true request parameter if it is present
            if (queryParams.desktop === 'true') {
                queryParams.desktop = null; // setQueryParams removes null values
                setQueryParams(queryParams, true);
            } else window.location.reload();
        });
        $796a872a5806d472$var$_defineProperty(this, "getSwitchToMobileHref", ()=>{
            const { getQueryParams: getQueryParams } = this.props;
            const queryParams = getQueryParams();
            const url = new URL(window.location.href);
            if (queryParams.desktop === 'true') url.searchParams.delete('desktop');
             // Resulting URL is same page, non-desktop override
            return url.toString();
        });
    }
});


class $019e7af3f6f4f87e$export$4207093557acd0c0 extends (0, $cozmU.Component) {
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7zgzO.RoutesContext).Consumer, null, ({ getQueryParams: getQueryParams, setQueryParams: setQueryParams })=>{
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $796a872a5806d472$export$5945f0cd1996f6fc), {
                getQueryParams: getQueryParams,
                setQueryParams: setQueryParams,
                ...this.props
            });
        });
    }
}






var $4NX9d = parcelRequire("4NX9d");


var $jln20 = parcelRequire("jln20");








var $9wGTI = parcelRequire("9wGTI");


var $6yagU = parcelRequire("6yagU");





var $8zMP3 = parcelRequire("8zMP3");








function $bd51a8c87efeb5a5$export$cfc1361be0de4203({ noOpSSRInlineScript: noOpSSRInlineScript }) {
    /**
   * Should only inline this script while SSR,
   * not needed on the client side.
   */ // For hydrateRoot there is a mismatch on client for this script.
    // So we want to add the script on client side but guard it with check to
    // not execute logic
    if (typeof window !== 'undefined' && !window.navigator.userAgent.includes('jsdom')) {
        if (!noOpSSRInlineScript) return null;
        else window.__RENDERER_BYPASS_BREAKOUT_SSR__ = true;
    }
    const context = $bd51a8c87efeb5a5$export$92859d13f30c883e();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("script", {
        // To investigate if we can replace this.
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML: {
            __html: context
        }
    });
}
function $bd51a8c87efeb5a5$export$92859d13f30c883e() {
    return `
  (function(window){
		if(typeof window !== 'undefined' && window.__RENDERER_BYPASS_BREAKOUT_SSR__) {
			return;
		}
		${$bd51a8c87efeb5a5$export$47813c4121c8b4b3};
    (${$bd51a8c87efeb5a5$export$a125785b9fe77113.toString()})(breakoutConstsInner);
  })(window);
 `;
}
const $bd51a8c87efeb5a5$export$47813c4121c8b4b3 = `
	var breakoutConstsInner = {};
  breakoutConstsInner.presetConnectAppsWrapperDimension = ${(0, $bd143360dd0cf955$export$a25046a8b24b3fc6).toString()};
`;
function $bd51a8c87efeb5a5$export$a125785b9fe77113(breakoutConstsInner) {
    // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    const breakoutContainer = document.querySelector("[data-connect-container='fixed-atl-general-wrapper']");
    if (!breakoutContainer) return;
    const totalHeight = breakoutConstsInner?.presetConnectAppsWrapperDimension(breakoutContainer);
    if (totalHeight) {
        // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
        document.documentElement.style.setProperty('--atl-general-webpanel-height', `${totalHeight}px`);
        // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
        document.dispatchEvent(new CustomEvent('atlGeneralWebPanelHeightUpdated'));
        window['__ATL_GENERAL_WEBPANEL_INITIAL_HEIGHT__'] = totalHeight;
    }
}


/* ForgeApps.tsx generated by @compiled/babel-plugin v3.0.2 */ 












var $aJv6Q = parcelRequire("aJv6Q");





var $irVI7 = parcelRequire("irVI7");


var $ln0hx = parcelRequire("ln0hx");








var $7QUD1 = parcelRequire("7QUD1");


var $hIaUw = parcelRequire("hIaUw");


var $8a9Dm = parcelRequire("8a9Dm");


var $8wW9d = parcelRequire("8wW9d");


var $dizL5 = parcelRequire("dizL5");











var $6uUjl = parcelRequire("6uUjl");

const $b7830f7e8969acd1$var$invisible = null;
const $b7830f7e8969acd1$export$afbabe4d2446fca2 = (forgeModules, loading, error)=>{
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const [{ contentId: contentId, routeName: routeName, spaceKey: spaceAlias }] = (0, $ep3mz.usePageState)();
    const { spaceId: spaceId, spaceKey: spaceKey, loading: spaceLoading } = (0, $6uUjl.useSpaceIdentifiers)((0, $9wGTI.fg)('confluence_forge_background_space_context_fix') ? spaceAlias ?? '' : undefined);
    if (loading) return null;
    if (error) {
        if (!(0, $7Sm4c.isErrorMarkedAsHandled)(error)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b3j2Y.ErrorDisplay), {
            error: error
        });
        return null;
    } // Instrument the presence of non-content 3P background-script apps so their
    // keys are folded into the page-load `connectAppKeys` telemetry.
    (0, $8wW9d.recordNonContentAppKeys)('background-script', forgeModules.map((app)=>app?.id));
    if (spaceAlias && spaceLoading && (0, $9wGTI.fg)('confluence_forge_background_space_context_fix')) return null;
    return forgeModules.map((0, $aJv6Q.withErrorBoundary)({
        attribution: (0, $3IBnw.Attribution).ECOSYSTEM
    })((app)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4PPzL.ErrorBoundary), {
            key: (0, $8a9Dm.getAppId)(app),
            attributes: {
                appId: (0, $8a9Dm.getAppId)(app)
            },
            attribution: (0, $3IBnw.Attribution).ECOSYSTEM
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            className: (0, $hekY6.default)([
                "_3iDTPbYbGa"
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ln0hx.ExperienceStart), {
            name: (0, $irVI7.BACKGROUND_SCRIPT_APPS_FORGE_EXPERIENCE),
            id: (0, $8a9Dm.getAppId)(app)
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7QUD1.BackgroundScriptForgeApp), {
            app: app,
            // Adding the pageRoute to the extensionData will allow the Forge app to re-render when the route changes
            extensionData: {
                type: (0, $7Ndnw.FORGE_MODULE_BACKGROUND_SCRIPT),
                ...contentId ? {
                    content: {
                        id: contentId,
                        type: (0, $hIaUw.getContentType)(routeName),
                        subtype: isLivePage ? 'live' : null
                    }
                } : {},
                ...spaceKey || spaceAlias ? {
                    space: {
                        id: spaceId,
                        key: spaceKey || spaceAlias
                    }
                } : {}
            }
        })))));
};
const $b7830f7e8969acd1$var$BackgroundScriptAppsWithSpaceKey = ()=>{
    const [{ spaceKey: spaceKey }] = (0, $ep3mz.usePageState)(); // Reset the lookup on space changes: it can retain the previous space with loading=false.
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dizL5.LazyForgeUIExtensions), {
        key: spaceKey,
        moduleType: (0, $7Ndnw.FORGE_MODULE_BACKGROUND_SCRIPT),
        render: $b7830f7e8969acd1$export$afbabe4d2446fca2
    });
};
const $b7830f7e8969acd1$export$f0362fceef532aae = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).memo(()=>(0, $9wGTI.fg)('confluence_forge_background_space_context_fix') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b7830f7e8969acd1$var$BackgroundScriptAppsWithSpaceKey, null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dizL5.LazyForgeUIExtensions), {
        moduleType: (0, $7Ndnw.FORGE_MODULE_BACKGROUND_SCRIPT),
        render: $b7830f7e8969acd1$export$afbabe4d2446fca2
    }));
const $b7830f7e8969acd1$var$PageBannerForgeAppWithErrorBoundary = (0, $aJv6Q.withErrorBoundary)({
    attribution: (0, $3IBnw.Attribution).ECOSYSTEM
})(({ app: app, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4PPzL.ErrorBoundary), {
        attributes: {
            appId: (0, $8a9Dm.getAppId)(app)
        },
        attribution: (0, $3IBnw.Attribution).ECOSYSTEM
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7QUD1.PageBannerForgeApp), {
        app: app,
        ...props
    }))); // This is exported solely for testing purposes
const $b7830f7e8969acd1$export$d778357d5618ef80 = (forgeModules, loading, error)=>{
    const [{ contentId: contentId, routeName: routeName, spaceKey: spaceAlias }] = (0, $ep3mz.usePageState)();
    const { spaceId: spaceId, spaceKey: spaceKey } = (0, $6uUjl.useSpaceIdentifiers)();
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    if (loading) return null;
    if (error) {
        if (!(0, $7Sm4c.isErrorMarkedAsHandled)(error)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b3j2Y.ErrorDisplay), {
            error: error
        });
        return null;
    } // Instrument the presence of non-content 3P page-banner apps so their keys are
    // folded into the page-load `connectAppKeys` telemetry.
    (0, $8wW9d.recordNonContentAppKeys)('page-banner', forgeModules.map((app)=>app?.id)); // A shared preset height is only safe for one Custom UI banner; UI Kit does not use an iframe.
    const shouldPresetHeight = forgeModules.length === 1 && forgeModules[0]?.properties?.resource != null && forgeModules[0]?.properties?.render !== 'native';
    const pageBannerProps = {
        shouldPresetHeight: shouldPresetHeight,
        extensionData: {
            type: (0, $7Ndnw.FORGE_MODULE_PAGE_BANNER),
            ...contentId ? {
                content: {
                    id: contentId,
                    type: (0, $hIaUw.getContentType)(routeName),
                    subtype: isLivePage ? 'live' : null
                }
            } : {},
            ...spaceKey || spaceAlias ? {
                space: {
                    id: spaceId,
                    key: spaceKey || spaceAlias
                }
            } : {}
        }
    };
    return forgeModules.map((app)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b7830f7e8969acd1$var$PageBannerForgeAppWithErrorBoundary, {
            key: `${(0, $8a9Dm.getAppId)(app)}:${contentId ?? ''}`,
            app: app,
            ...pageBannerProps
        }));
};
const $b7830f7e8969acd1$export$910fc80855ba5fda = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).memo(()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dizL5.LazyForgeUIExtensions), {
        moduleType: (0, $7Ndnw.FORGE_MODULE_PAGE_BANNER),
        render: $b7830f7e8969acd1$export$d778357d5618ef80
    });
});


const $4e0d0b830c02a893$var$webPanelWrapperStyles = {
    showPanel: "_3iDTPbvLZJ",
    hidePanel: "_3iDTPbYbGa"
};
const $4e0d0b830c02a893$var$contentBodyWrapperStyles = null;
const $4e0d0b830c02a893$var$fillContainerStyles = {
    container: "_3iDTPbQ4SZ _0aFT5vbt8w _3TGfC9LRg7 _0jFU0VN91d _4kiQYAdnbC",
    body: "_2O5Vij7dHp _3YEZNO7dHp _1bHrqEAEMG _3iDTPbQ4SZ _0aFT5vbt8w _4kiQYAdnbC"
};
const $4e0d0b830c02a893$var$fixedWebPanelSpacerStyles = null;
const $4e0d0b830c02a893$var$fixedForgeBannerSpacerStyles = null;
const $4e0d0b830c02a893$var$mainContentContainerStyles = {
    default: "_23rrnH647S _0aFT5v1qpb _3TGfC9HnLE _39xV02N91d _2XsHFMPgdg _4eDzxwTTQh",
    addMinWidth: "_4ouGXIELL6"
};
const $4e0d0b830c02a893$var$fixedWebPanelWrapperStyles = {
    default: "_3iDTPbYbGa _42Yu6BaZ2J _39xV02N91d _1mT5xdy1CL _0KLXrulfZc _3OE6xY1nKm _1EqgXluI1V",
    showPanel: "_3iDTPbvLZJ"
}; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $4e0d0b830c02a893$var$ContentBody = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_0Of8r2dnbC _1ZnuxbdnbC _1wydGWdnbC _2Zuz6QdnbC _0KLXrulfZc _24h04i2Njc _1RrJLiBwqQ _4kiQYAIZbP _39xV02N91d",
            __cmplp.className
        ])
    });
});
const $4e0d0b830c02a893$var$BANNER_STATE_CONTAINERS = [
    (0, $hrAmX.BannerStateContainer)
];
const $4e0d0b830c02a893$var$MainLayoutInnerContent = ({ fillContainer: fillContainer, enableNavigation: enableNavigation = true, disableMinWidth: disableMinWidth, screen: screen, isViewPage: isViewPage = false, isEdit: isEdit, children: children, isLivePage: isLivePage, ommitComponentsNotNeededForPdfExport: ommitComponentsNotNeededForPdfExport, renderServerPlaceholder: renderServerPlaceholder })=>{
    const { shouldShowATLGeneralWebPanel: shouldShowATLGeneralWebPanel, isATLGeneralWebPanelFixed: isATLGeneralWebPanelFixed, fixedATLGeneralWebPanelRef: fixedATLGeneralWebPanelRef, shouldHidePanels: shouldHidePanels } = (0, $9739cc17e95eb22c$export$8610b0674aff537e)(isViewPage, isEdit);
    const { isForgePageBannerFixed: isForgePageBannerFixed, fixedForgePageBannerRef: fixedForgePageBannerRef, shouldHideForgePageBanner: shouldHideForgePageBanner, hasPreloadedForgePageBanners: hasPreloadedForgePageBanners, mantraNavigationHeight: mantraNavigationHeight } = (0, $062cf5e7a1742c3e$export$a6ca923c8089e1e8)(isViewPage, true, isEdit);
    const rightSidebarContext = (0, $jln20.useRightSidebarContext)();
    const [enableRightSidebarCSS, setEnableRightSidebarCSS] = (0, $cozmU.useState)(false);
    const shouldRenderATLGeneralWebPanel = shouldShowATLGeneralWebPanel && !ommitComponentsNotNeededForPdfExport;
    const shouldOmitATLFooterWebPanel = isEdit || isLivePage || ommitComponentsNotNeededForPdfExport || renderServerPlaceholder;
    const topElementStyle = {};
    if (screen) for(const key in screen){
        if (screen.hasOwnProperty(key)) {
            if (key.startsWith('background')) topElementStyle[key] = screen[key];
        }
    }
    const forgePageBannerInitialHeight = mantraNavigationHeight > 0 && (0, $6mKj3.expValEquals)('cc_mantra_navigation_height', 'isEnabled', true) ? mantraNavigationHeight : (0, $1jwVN.getForgeBannerPresetHeightConfig)().presetHeight;
    const shouldUseForgePageBannerInitialHeight = forgePageBannerInitialHeight > 5 && hasPreloadedForgePageBanners !== false;
    (0, $cozmU.useEffect)(()=>{
        if (rightSidebarContext.getCurrent()) setEnableRightSidebarCSS(true);
    }, [
        rightSidebarContext
    ]);
    const AtlGeneralWebPanel = isATLGeneralWebPanelFixed ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        ref: fixedATLGeneralWebPanelRef,
        "data-test-id": "fixed-atl-general-wrapper",
        "data-connect-container": "fixed-atl-general-wrapper",
        className: (0, $hekY6.default)([
            $4e0d0b830c02a893$var$fixedWebPanelWrapperStyles['default'],
            !shouldHidePanels && $4e0d0b830c02a893$var$fixedWebPanelWrapperStyles['showPanel']
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9Z1sw.WebPanelLocation), {
        location: (0, $eSLr0.ATL_GENERAL),
        fetchPolicy: "cache-first"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            "_0jFU0VjOtr"
        ])
    }), renderServerPlaceholder && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bd51a8c87efeb5a5$export$cfc1361be0de4203), {
        noOpSSRInlineScript: renderServerPlaceholder
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        "data-test-id": "atl-general-wrapper",
        className: (0, $hekY6.default)([
            $4e0d0b830c02a893$var$webPanelWrapperStyles['showPanel'],
            shouldHidePanels && $4e0d0b830c02a893$var$webPanelWrapperStyles['hidePanel']
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9Z1sw.WebPanelLocation), {
        location: (0, $eSLr0.ATL_GENERAL),
        fetchPolicy: "cache-first"
    }));
    const ForgePageBannerExtensionPoint = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        "data-test-id": isForgePageBannerFixed ? 'fixed-forge-page-banner-wrapper-compiled' : 'forge-page-banner-wrapper-compiled',
        ref: fixedForgePageBannerRef,
        ...shouldUseForgePageBannerInitialHeight ? {
            style: {
                minHeight: `${forgePageBannerInitialHeight}px`
            }
        } : {},
        className: (0, $hekY6.default)([
            isForgePageBannerFixed && $4e0d0b830c02a893$var$fixedWebPanelWrapperStyles['default'],
            isForgePageBannerFixed && !shouldHideForgePageBanner && $4e0d0b830c02a893$var$fixedWebPanelWrapperStyles['showPanel'],
            !isForgePageBannerFixed && $4e0d0b830c02a893$var$webPanelWrapperStyles['showPanel'],
            !isForgePageBannerFixed && shouldHideForgePageBanner && $4e0d0b830c02a893$var$webPanelWrapperStyles['hidePanel']
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b7830f7e8969acd1$export$910fc80855ba5fda), null)), isForgePageBannerFixed && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        ...shouldUseForgePageBannerInitialHeight ? {
            style: {
                minHeight: `${forgePageBannerInitialHeight}px`
            }
        } : {},
        className: (0, $hekY6.default)([
            "_0jFU0VNIFp"
        ])
    }));
    const renderContentBody = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            className: (0, $hekY6.default)([
                "_2O5VijdnbC _3YEZNO7dHp _1bHrqEIZbP _313842dnbC _24h04i2Njc _2uxTLTZSoF _1mT5xdRAKS _39xV02N91d _3iDTPbQ4SZ _4kiQYAZqHV",
                fillContainer && (0, $9wGTI.fg)('rovo_fps_fix_duplicate_scrollbars') && $4e0d0b830c02a893$var$fillContainerStyles.body
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($4e0d0b830c02a893$var$ContentBody, {
            "data-test-id": "content-body",
            "data-vc": "content-body-compiled",
            id: "content-body",
            style: topElementStyle,
            className: (0, $hekY6.default)([
                fillContainer && (0, $9wGTI.fg)('rovo_fps_fix_duplicate_scrollbars') && $4e0d0b830c02a893$var$fillContainerStyles.body
            ])
        }, children));
    const mainLayoutContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
    , {
        className: (0, $hekY6.default)([
            $4e0d0b830c02a893$var$mainContentContainerStyles['default'],
            fillContainer && (0, $9wGTI.fg)('rovo_fps_fix_duplicate_scrollbars') && $4e0d0b830c02a893$var$fillContainerStyles.container,
            !enableRightSidebarCSS && !(disableMinWidth || !enableNavigation) && $4e0d0b830c02a893$var$mainContentContainerStyles['addMinWidth'],
            "confluence-main-content"
        ]),
        "data-test-id": "confluence-main-content",
        "data-vc": "confluence-main-content-compiled"
    }, shouldRenderATLGeneralWebPanel && AtlGeneralWebPanel, ForgePageBannerExtensionPoint, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $019e7af3f6f4f87e$export$4207093557acd0c0), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, (0, $6mKj3.expValEquals)('confluence_banner_store_migration', 'isEnabled', true) ? renderContentBody() : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kNIYN.Subscribe), {
        to: $4e0d0b830c02a893$var$BANNER_STATE_CONTAINERS
    }, renderContentBody), !shouldOmitATLFooterWebPanel && (!fillContainer || !(0, $9wGTI.fg)('rovo_fps_fix_duplicate_scrollbars')) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        "data-test-id": "atl-footer-wrapper",
        className: (0, $hekY6.default)([
            $4e0d0b830c02a893$var$webPanelWrapperStyles['showPanel'],
            shouldHidePanels && $4e0d0b830c02a893$var$webPanelWrapperStyles['hidePanel']
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9Z1sw.WebPanelLocation), {
        location: (0, $eSLr0.ATL_FOOTER),
        // server rendered, invalidating the hydrated DOM. ATL_GENERAL passes `cache-first`
        // for the same reason.
        fetchPolicy: "cache-first"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b7830f7e8969acd1$export$f0362fceef532aae), null)));
    return children ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4PPzL.ErrorBoundary), {
        attribution: (0, $3IBnw.Attribution).BACKBONE
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("style" // eslint-disable-next-line react/no-danger
    , {
        dangerouslySetInnerHTML: {
            __html: `.confluence-main-content .cp-container [role='dialog'] { z-index: 350; }`
        }
    }), mainLayoutContent) : null;
};
const $4e0d0b830c02a893$export$80006b81bf20e108 = (props)=>{
    const { isViewPage: isViewPage = false, isEdit: isEdit } = props;
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const browserLocation = typeof globalThis.window?.location !== 'undefined' ? globalThis.window.location : undefined;
    const isPdfExport = browserLocation !== undefined && Boolean((0, $1NBp8.PDF_EXPORT_PAGE).match(browserLocation.pathname));
    const ommitComponentsNotNeededForPdfExport = isPdfExport;
    const renderServerPlaceholder = (0, $1P7Cq.useIsSSROrHydrating)();
    let webPanelBatchLocations = [];
    if (!ommitComponentsNotNeededForPdfExport) {
        if (isViewPage || isEdit) webPanelBatchLocations = [
            (0, $eSLr0.ATL_GENERAL),
            (0, $eSLr0.ATL_FOOTER)
        ];
    }
    const shouldRenderWebPanelBatchProvider = webPanelBatchLocations.length > 0 && (0, $6mKj3.expValEquals)('web_panel_query_batch_call', 'isEnabled', true);
    const content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($4e0d0b830c02a893$var$MainLayoutInnerContent, {
        ...props,
        isLivePage: isLivePage,
        ommitComponentsNotNeededForPdfExport: ommitComponentsNotNeededForPdfExport,
        renderServerPlaceholder: renderServerPlaceholder
    });
    return shouldRenderWebPanelBatchProvider ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9Z1sw.WebPanelLocationBatchProvider), {
        locations: webPanelBatchLocations
    }, content) : content;
};
const $4e0d0b830c02a893$export$375787c0d3c11135 = (props)=>{
    const { editorPreloader: editorPreloader, navView: navView, enableNavigation: enableNavigation = true } = props;
    const [preloader, setPreloader] = (0, $cozmU.useState)();
    const setEditorPreloader = async ()=>{
        if (editorPreloader) {
            const newPreloader = await editorPreloader();
            setPreloader(newPreloader);
        }
    };
    (0, $cozmU.useEffect)(()=>{
        setEditorPreloader(); // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8zMP3.SuspenseWithDataFetcher), {
        dataFetcherName: "default"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($4e0d0b830c02a893$export$80006b81bf20e108, props));
    content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, enableNavigation ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5ZPtT.PageLayout), {
        editorPreloader: preloader,
        view: navView,
        fillContainer: props.fillContainer
    }, content) : content, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4NX9d.PerformanceEnd), {
        subject: (0, $kVysQ.PERFORMANCE_SUBJECT_mainLayout)
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6yagU.ConfluencePreviewPanelsProvider), null, content);
};


const $a171d54840e7d827$var$MainLayoutQuery = (0, $52181a874b01b0e6$export$2e2bcd8739ae039);
const $a171d54840e7d827$export$93af822566053b3e = /*#__PURE__*/ (0, $cozmU.memo)(({ spaceKey: spaceKey, isEdit: isEdit, enableNavigation: enableNavigation, isViewPage: isViewPage, ...otherProps })=>{
    const isEmbeddedConfluence = (0, $5vi32.useIsEmbeddedConfluence_DO_NOT_USE)();
    const isMobileApp = (0, $lJlG6.isMobileApp_DO_NOT_USE)();
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const { data: data, error: unhandledError } = (0, $jMyy4.useQueryInterop)($a171d54840e7d827$var$MainLayoutQuery, {
        variables: {
            // When spaceKey is undefined/falsy the query is skipped, so defaulting it to
            // an empty string doesn't change the logic but merely keeps TypeScript happy.
            spaceKey: spaceKey || ''
        },
        skip: !spaceKey || isEdit || isLivePage,
        __callerPackage__: "main-layout"
    });
    let error = unhandledError;
    if ((0, $f9jv7.isNotFoundError)(error) || (0, $1uFM6.isUnauthorizedError)(error)) {
        // The MainLayoutQuery only loads the space styling configuration, and neither error nor
        // missing configuration don't break the user experience. Unauthorized or NotFound error
        // (anonymous user, restricted or missing space/page) are handled by children components
        // of MainLayout and are part of the normal user flow, hence these can be safely muted.
        (0, $7Sm4c.markErrorAsHandled)(error);
        error = undefined;
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b3j2Y.ErrorDisplay), {
        error: error
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6CEg5.PerformanceStart), {
        subject: (0, $kVysQ.PERFORMANCE_SUBJECT_mainLayout)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4e0d0b830c02a893$export$375787c0d3c11135), {
        ...otherProps,
        enableNavigation: isEmbeddedConfluence || isMobileApp ? false : enableNavigation,
        screen: data?.space?.lookAndFeel?.content?.screen ?? undefined,
        isViewPage: isViewPage,
        isEdit: isEdit
    }));
});
module.exports["MainLayout"] = $a171d54840e7d827$export$93af822566053b3e;

});

parcelRegister("kVysQ", function(module, exports) {
const $35b50a968705ed01$export$9960fc620d4470dd = 'comments';
const $35b50a968705ed01$export$c4d483efe8eba686 = 'link-to-page';
const $35b50a968705ed01$export$1de09ba64e7728f2 = 'main-layout';
const $35b50a968705ed01$export$586856ecee8f0723 = 'manage-watcher-dialog';
const $35b50a968705ed01$export$51f018e0f9f84a74 = 'Navigation';
const $35b50a968705ed01$export$94afb8303c61d07d = 'navigation-fmp';
const $35b50a968705ed01$export$fe596581250cd9fc = 'side-navigation-fmp';
const $35b50a968705ed01$export$88c949ed1e388f68 = 'NavigationView';
const $35b50a968705ed01$export$1a3cc5086fadf289 = 'recent-dropdown';
const $35b50a968705ed01$export$b35db70015797a33 = 'resolved-inline-comments-dialog';
const $35b50a968705ed01$export$5c78998b70cdff69 = 'copy-page-tree';
const $35b50a968705ed01$export$1167e4f56227df4c = 'space-directory';
module.exports["PERFORMANCE_SUBJECT_linkToPage"] = $35b50a968705ed01$export$c4d483efe8eba686;
module.exports["PERFORMANCE_SUBJECT_mainLayout"] = $35b50a968705ed01$export$1de09ba64e7728f2;
module.exports["PERFORMANCE_SUBJECT_manageWatcherDialog"] = $35b50a968705ed01$export$586856ecee8f0723;
module.exports["PERFORMANCE_SUBJECT_navigation"] = $35b50a968705ed01$export$51f018e0f9f84a74;
module.exports["PERFORMANCE_SUBJECT_navigationFMP"] = $35b50a968705ed01$export$94afb8303c61d07d;
module.exports["PERFORMANCE_SUBJECT_sideNavigationFMP"] = $35b50a968705ed01$export$fe596581250cd9fc;
module.exports["PERFORMANCE_SUBJECT_navigationView"] = $35b50a968705ed01$export$88c949ed1e388f68;
module.exports["PERFORMANCE_SUBJECT_resolvedInlineCommentsDialog"] = $35b50a968705ed01$export$b35db70015797a33;
module.exports["PERFORMANCE_SUBJECT_copyPageTree"] = $35b50a968705ed01$export$5c78998b70cdff69;
module.exports["PERFORMANCE_SUBJECT_spaceDirectory"] = $35b50a968705ed01$export$1167e4f56227df4c;

});

parcelRegister("5ZPtT", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $5ea117b10605f60a$export$6d1402fb58384e4f = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "OP-5u",
    name: "PageLayout",
    loader: async ()=>(await (parcelRequire("hK6ZP"))).PageLayout
});
module.exports["PageLayout"] = $5ea117b10605f60a$export$6d1402fb58384e4f;

});

parcelRegister("hK6ZP", function(module, exports) {

let $ceac28d3ac46c9bf$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $ceac28d3ac46c9bf$var$load("i8sPk"),
    $ceac28d3ac46c9bf$var$load("44XW6"),
    $ceac28d3ac46c9bf$var$load("aRCaA"),
    $ceac28d3ac46c9bf$var$load("h3Rq9"),
    $ceac28d3ac46c9bf$var$load("fYx6U"),
    $ceac28d3ac46c9bf$var$load("botpL"),
    $ceac28d3ac46c9bf$var$load("l4j2l"),
    $ceac28d3ac46c9bf$var$load("37v60"),
    $ceac28d3ac46c9bf$var$load("eF92L"),
    $ceac28d3ac46c9bf$var$load("jwMHX"),
    $ceac28d3ac46c9bf$var$load("gaUhx"),
    $ceac28d3ac46c9bf$var$load("8iu3F"),
    $ceac28d3ac46c9bf$var$load("6wr18"),
    $ceac28d3ac46c9bf$var$load("1REma"),
    $ceac28d3ac46c9bf$var$load("eosOx"),
    $ceac28d3ac46c9bf$var$load("2EL9y"),
    $ceac28d3ac46c9bf$var$load("9jcs1"),
    $ceac28d3ac46c9bf$var$load("lHIG6"),
    $ceac28d3ac46c9bf$var$load("d3PpR"),
    $ceac28d3ac46c9bf$var$load("gpUln"),
    $ceac28d3ac46c9bf$var$load("bWtlo"),
    $ceac28d3ac46c9bf$var$load("1F9i1"),
    $ceac28d3ac46c9bf$var$load("1ElkK"),
    $ceac28d3ac46c9bf$var$load("gWjIZ"),
    $ceac28d3ac46c9bf$var$load("VXbA1"),
    $ceac28d3ac46c9bf$var$load("ea3NB"),
    $ceac28d3ac46c9bf$var$load("9TOep"),
    $ceac28d3ac46c9bf$var$load("gQrOI"),
    $ceac28d3ac46c9bf$var$load("248rq"),
    $ceac28d3ac46c9bf$var$load("dXWlR"),
    $ceac28d3ac46c9bf$var$load("11yNG"),
    $ceac28d3ac46c9bf$var$load("gQYVn"),
    $ceac28d3ac46c9bf$var$load("9RGBF"),
    $ceac28d3ac46c9bf$var$load("cpTbC"),
    $ceac28d3ac46c9bf$var$load("fhT77"),
    $ceac28d3ac46c9bf$var$load("jvUhP"),
    $ceac28d3ac46c9bf$var$load("7sOKp"),
    $ceac28d3ac46c9bf$var$load("7Ysw6"),
    $ceac28d3ac46c9bf$var$load("3xL2F"),
    $ceac28d3ac46c9bf$var$load("kMyku"),
    $ceac28d3ac46c9bf$var$load("hG1ar"),
    $ceac28d3ac46c9bf$var$load("ffEVr"),
    $ceac28d3ac46c9bf$var$load("2xoIF"),
    $ceac28d3ac46c9bf$var$load("9BBvG"),
    $ceac28d3ac46c9bf$var$load("d0ZRF"),
    $ceac28d3ac46c9bf$var$load("k507P"),
    $ceac28d3ac46c9bf$var$load("cYv6T"),
    $ceac28d3ac46c9bf$var$load("el1U6"),
    $ceac28d3ac46c9bf$var$load("2yyll"),
    $ceac28d3ac46c9bf$var$load("bncmK"),
    $ceac28d3ac46c9bf$var$load("4XCbb"),
    $ceac28d3ac46c9bf$var$load("10Qad"),
    $ceac28d3ac46c9bf$var$load("6iTkp"),
    $ceac28d3ac46c9bf$var$load("hhss7"),
    $ceac28d3ac46c9bf$var$load("aAWLw"),
    $ceac28d3ac46c9bf$var$load("7EorR"),
    $ceac28d3ac46c9bf$var$load("gmHzx")
]).then(()=>parcelRequire('48Eol'));

});

parcelRegister("3b6WO", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $kSwu1 = parcelRequire("kSwu1");


var $cozmU = parcelRequire("cozmU");


var $isuYJ = parcelRequire("isuYJ");


var $hzmpb = parcelRequire("hzmpb");


var $9wGTI = parcelRequire("9wGTI");


var $ep3mz = parcelRequire("ep3mz");


var $dPJCf = parcelRequire("dPJCf");


var $bQm3c = parcelRequire("bQm3c");


var $kqIWy = parcelRequire("kqIWy");


var $bFDX4 = parcelRequire("bFDX4");


var $1uFM6 = parcelRequire("1uFM6");


var $7Sm4c = parcelRequire("7Sm4c");


var $7Ndnw = parcelRequire("7Ndnw");


var $6qkXi = parcelRequire("6qkXi");

/**
 * Discovery is filtered by space/page, visibility and context mode, so SSR data
 * (including an empty list) is reusable only for an equivalent request. Space-only
 * requests intentionally ignore contentId. Callers check module eligibility,
 * errors and snapshot lifetime separately.
 */ const $8eb9026be26e0c85$var$matchesExtensionListContext = (preloadedContext, currentContext)=>preloadedContext !== undefined && preloadedContext.spaceKey === currentContext.spaceKey && preloadedContext.includeHidden === currentContext.includeHidden && preloadedContext.spaceContextOnly === currentContext.spaceContextOnly && (currentContext.spaceContextOnly || preloadedContext.contentId === currentContext.contentId);
const $8eb9026be26e0c85$export$cab421e039d23b2 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(28);
    const { moduleType: moduleType, queryOptions: queryOptions, returnBlockedExtensions: t1, skipQuery: t2, spaceContextOnly: spaceContextOnly, skipSpaceDetail: t3, attachmentId: attachmentId, contentId: providedContentId, spaceKey: providedSpaceKey } = t0;
    const returnBlockedExtensions = t1 === undefined ? false : t1;
    const skipQuery = t2 === undefined ? false : t2;
    const skipSpaceDetail = t3 === undefined ? false : t3;
    const { locale: locale } = (0, $kSwu1.useIntl)();
    const isTransition = (0, $dPJCf.useIsTransition)();
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const [pageSpaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const spaceKey = providedSpaceKey || pageSpaceKey;
    const [pageContentId] = (0, $ep3mz.usePageContentId)();
    const contentId = providedContentId || pageContentId;
    const resolvedAttachmentId = attachmentId && (0, $9wGTI.fg)("forge_attachment_display_conditions") ? attachmentId : undefined;
    let t4;
    if ($[0] !== skipSpaceDetail) {
        t4 = {
            skip: skipSpaceDetail
        };
        $[0] = skipSpaceDetail;
        $[1] = t4;
    } else t4 = $[1];
    const { error: spaceError } = (0, $kqIWy.useSpaceDetail)(spaceKey, t4);
    let t5;
    if ($[2] !== moduleType) {
        t5 = ()=>window.__SSR_FORGE_EXTENSIONS__?.[moduleType];
        $[2] = moduleType;
        $[3] = t5;
    } else t5 = $[3];
    const [ssrExtensionResult] = (0, $cozmU.useState)(t5);
    const currentContext = {
        spaceKey: spaceKey,
        contentId: contentId,
        includeHidden: returnBlockedExtensions,
        spaceContextOnly: Boolean(spaceContextOnly)
    };
    const pageBannerSSRResult = !skipQuery && !resolvedAttachmentId && moduleType === (0, $7Ndnw.FORGE_MODULE_PAGE_BANNER) && !isTransition ? ssrExtensionResult : undefined;
    const preloadedPageBanners = pageBannerSSRResult !== undefined && !pageBannerSSRResult.error && $8eb9026be26e0c85$var$matchesExtensionListContext(pageBannerSSRResult.context, currentContext) ? pageBannerSSRResult : undefined;
    const t6 = skipQuery || preloadedPageBanners !== undefined;
    let t7;
    if ($[4] !== cloudId || $[5] !== contentId || $[6] !== locale || $[7] !== moduleType || $[8] !== queryOptions || $[9] !== resolvedAttachmentId || $[10] !== returnBlockedExtensions || $[11] !== spaceContextOnly || $[12] !== spaceKey || $[13] !== t6) {
        t7 = (0, $6qkXi.getUsePrefilteredExtensionListOptions)({
            cloudId: cloudId,
            locale: locale,
            moduleType: moduleType,
            queryOptions: {
                ...queryOptions,
                skip: t6
            },
            includeHidden: returnBlockedExtensions,
            spaceKey: spaceKey,
            contentId: contentId,
            ...resolvedAttachmentId ? {
                attachmentId: resolvedAttachmentId
            } : {},
            spaceContextOnly: spaceContextOnly
        });
        $[4] = cloudId;
        $[5] = contentId;
        $[6] = locale;
        $[7] = moduleType;
        $[8] = queryOptions;
        $[9] = resolvedAttachmentId;
        $[10] = returnBlockedExtensions;
        $[11] = spaceContextOnly;
        $[12] = spaceKey;
        $[13] = t6;
        $[14] = t7;
    } else t7 = $[14];
    const options = t7;
    const { extensions: extsData, loading: extsLoading, error: extsError } = $8eb9026be26e0c85$var$usePrefilteredExtensionList(options);
    let t8;
    let t9;
    if ($[15] !== extsError || $[16] !== spaceError) {
        t8 = ()=>{
            if (extsError && (0, $1uFM6.isUnauthorizedError)(extsError)) (0, $7Sm4c.markErrorAsHandled)(extsError);
            if ((0, $bFDX4.isTooManyRequestsError)(extsError)) (0, $7Sm4c.markErrorAsHandled)(extsError);
            if (spaceError) (0, $7Sm4c.markErrorAsHandled)(spaceError);
        };
        t9 = [
            extsError,
            spaceError
        ];
        $[15] = extsError;
        $[16] = spaceError;
        $[17] = t8;
        $[18] = t9;
    } else {
        t8 = $[17];
        t9 = $[18];
    }
    (0, $cozmU.useEffect)(t8, t9);
    if (preloadedPageBanners) {
        let t10;
        if ($[19] !== preloadedPageBanners.extensions) {
            t10 = {
                extensions: preloadedPageBanners.extensions,
                loading: false,
                error: undefined,
                isSSRResult: true
            };
            $[19] = preloadedPageBanners.extensions;
            $[20] = t10;
        } else t10 = $[20];
        return t10;
    }
    if (!skipQuery && extsLoading && ssrExtensionResult !== undefined && $8eb9026be26e0c85$var$matchesExtensionListContext(ssrExtensionResult.context, currentContext) && (moduleType === (0, $7Ndnw.FORGE_MODULE_SPACE_PAGE) || moduleType === (0, $7Ndnw.FORGE_MODULE_BYLINE))) {
        let t10;
        if ($[21] !== ssrExtensionResult.error || $[22] !== ssrExtensionResult.extensions) {
            t10 = {
                extensions: ssrExtensionResult.extensions,
                loading: false,
                error: ssrExtensionResult.error
            };
            $[21] = ssrExtensionResult.error;
            $[22] = ssrExtensionResult.extensions;
            $[23] = t10;
        } else t10 = $[23];
        return t10;
    }
    let t10;
    if ($[24] !== extsData || $[25] !== extsError || $[26] !== extsLoading) {
        t10 = {
            extensions: extsData,
            loading: extsLoading,
            error: extsError
        };
        $[24] = extsData;
        $[25] = extsError;
        $[26] = extsLoading;
        $[27] = t10;
    } else t10 = $[27];
    return t10;
} : ({ moduleType: moduleType, queryOptions: queryOptions, returnBlockedExtensions: returnBlockedExtensions = false, skipQuery: skipQuery = false, spaceContextOnly: spaceContextOnly, skipSpaceDetail: skipSpaceDetail = false, attachmentId: attachmentId, contentId: providedContentId, spaceKey: providedSpaceKey })=>{
    const { locale: locale } = (0, $kSwu1.useIntl)();
    const isTransition = (0, $dPJCf.useIsTransition)();
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const [pageSpaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const spaceKey = providedSpaceKey || pageSpaceKey;
    const [pageContentId] = (0, $ep3mz.usePageContentId)();
    const contentId = providedContentId || pageContentId;
    const resolvedAttachmentId = // oxlint-disable-next-line confluence-feature-gating/no-new-feature-gates
    attachmentId && (0, $9wGTI.fg)('forge_attachment_display_conditions') ? attachmentId : undefined;
    const { error: spaceError } = (0, $kqIWy.useSpaceDetail)(spaceKey, {
        skip: skipSpaceDetail
    });
    const [ssrExtensionResult] = (0, $cozmU.useState)(()=>window.__SSR_FORGE_EXTENSIONS__?.[moduleType]);
    const currentContext = {
        spaceKey: spaceKey,
        contentId: contentId,
        includeHidden: returnBlockedExtensions,
        spaceContextOnly: Boolean(spaceContextOnly)
    };
    // The boot payload belongs to the initial route. Never reuse it after navigation,
    // including when the user returns to the page that originally produced it.
    const pageBannerSSRResult = !skipQuery && !resolvedAttachmentId && moduleType === (0, $7Ndnw.FORGE_MODULE_PAGE_BANNER) && !isTransition ? ssrExtensionResult : undefined;
    const preloadedPageBanners = pageBannerSSRResult !== undefined && !pageBannerSSRResult.error && $8eb9026be26e0c85$var$matchesExtensionListContext(pageBannerSSRResult.context, currentContext) ? pageBannerSSRResult : undefined;
    const options = (0, $cozmU.useMemo)(()=>(0, $6qkXi.getUsePrefilteredExtensionListOptions)({
            cloudId: cloudId,
            locale: locale,
            moduleType: moduleType,
            queryOptions: {
                ...queryOptions,
                skip: skipQuery || preloadedPageBanners !== undefined
            },
            includeHidden: returnBlockedExtensions,
            spaceKey: spaceKey,
            contentId: contentId,
            ...resolvedAttachmentId ? {
                attachmentId: resolvedAttachmentId
            } : {},
            spaceContextOnly: spaceContextOnly
        }), [
        cloudId,
        locale,
        moduleType,
        queryOptions,
        returnBlockedExtensions,
        skipQuery,
        preloadedPageBanners,
        spaceKey,
        contentId,
        resolvedAttachmentId,
        spaceContextOnly
    ]);
    const { extensions: extsData, loading: extsLoading, error: extsError } = $8eb9026be26e0c85$var$usePrefilteredExtensionList(options);
    (0, $cozmU.useEffect)(()=>{
        // suppress 403 errors as we can't do much with them
        if (extsError && (0, $1uFM6.isUnauthorizedError)(extsError)) (0, $7Sm4c.markErrorAsHandled)(extsError);
        // suppress 429 errors for offending users
        if ((0, $bFDX4.isTooManyRequestsError)(extsError)) (0, $7Sm4c.markErrorAsHandled)(extsError);
        if (spaceError) (0, $7Sm4c.markErrorAsHandled)(spaceError);
    }, [
        extsError,
        spaceError
    ]);
    if (preloadedPageBanners) return {
        extensions: preloadedPageBanners.extensions,
        loading: false,
        error: undefined,
        isSSRResult: true
    };
    if (!skipQuery && extsLoading && ssrExtensionResult !== undefined && $8eb9026be26e0c85$var$matchesExtensionListContext(ssrExtensionResult.context, currentContext) && (moduleType === (0, $7Ndnw.FORGE_MODULE_SPACE_PAGE) || moduleType === (0, $7Ndnw.FORGE_MODULE_BYLINE))) return {
        extensions: ssrExtensionResult.extensions,
        loading: false,
        error: ssrExtensionResult.error
    };
    return {
        extensions: extsData,
        loading: extsLoading,
        error: extsError
    };
};
const $8eb9026be26e0c85$var$usePrefilteredExtensionList = (0, $isuYJ.conditionalHooksFactory)(// oxlint-disable-next-line confluence-feature-gating/no-new-feature-gates
()=>(0, $9wGTI.fg)('forge-ui-migrate-extension-list-query-to-relay'), (0, $hzmpb.usePrefilteredExtensionListRelay), (0, $hzmpb.usePrefilteredExtensionList));
module.exports["useExtensionList"] = $8eb9026be26e0c85$export$cab421e039d23b2;

});

parcelRegister("kqIWy", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $4ZxLt = parcelRequire("4ZxLt");


var $cozmU = parcelRequire("cozmU");


var $jtuBN = parcelRequire("jtuBN");


var $89u2G = parcelRequire("89u2G");

const $bbbfebced5e36727$export$7081570f83890156 = (spaceKey, t0)=>{
    const $ = (0, $bDgLe.c)(23);
    let t1;
    if ($[0] !== t0) {
        t1 = t0 === undefined ? {} : t0;
        $[0] = t0;
        $[1] = t1;
    } else t1 = $[1];
    const { includeSpaceTypeSettings: t2, skip: t3 } = t1;
    const includeSpaceTypeSettings = t2 === undefined ? false : t2;
    const skip = t3 === undefined ? false : t3;
    const sharedDetail = (0, $cozmU.useContext)((0, $89u2G.SpaceDetailContext));
    const canUseSharedDetail = Boolean(spaceKey) && sharedDetail?.spaceKey === spaceKey && (!includeSpaceTypeSettings || sharedDetail?.space?.spaceTypeSettings !== undefined);
    let t4;
    if ($[2] !== includeSpaceTypeSettings || $[3] !== spaceKey) {
        t4 = {
            spaceKey: spaceKey,
            includeSpaceTypeSettings: includeSpaceTypeSettings
        };
        $[2] = includeSpaceTypeSettings;
        $[3] = spaceKey;
        $[4] = t4;
    } else t4 = $[4];
    let t5;
    if ($[5] !== canUseSharedDetail || $[6] !== skip) {
        t5 = skip || canUseSharedDetail ? {
            skip: true
        } : {};
        $[5] = canUseSharedDetail;
        $[6] = skip;
        $[7] = t5;
    } else t5 = $[7];
    let t6;
    if ($[8] !== t4 || $[9] !== t5) {
        t6 = {
            variables: t4,
            ...t5
        };
        $[8] = t4;
        $[9] = t5;
        $[10] = t6;
    } else t6 = $[10];
    const options = t6;
    const legacyResult = (0, $jtuBN.useQueryNoFurtherUpdateInterop)((0, $4ZxLt.default), {
        ...options,
        __callerPackage__: "space-utils"
    });
    if (skip) {
        let t7;
        if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
            t7 = {
                loading: false
            };
            $[11] = t7;
        } else t7 = $[11];
        return t7;
    }
    let t7;
    if ($[12] !== canUseSharedDetail || $[13] !== legacyResult || $[14] !== sharedDetail) {
        t7 = canUseSharedDetail && sharedDetail ? {
            loading: sharedDetail.loading,
            data: sharedDetail.space ? {
                space: sharedDetail.space
            } : undefined,
            error: undefined
        } : legacyResult;
        $[12] = canUseSharedDetail;
        $[13] = legacyResult;
        $[14] = sharedDetail;
        $[15] = t7;
    } else t7 = $[15];
    const { loading: loading, data: data, error: error } = t7;
    let t8;
    if ($[16] !== data || $[17] !== includeSpaceTypeSettings) {
        t8 = data ? {
            spaceId: data.space?.id,
            type: data.space?.type,
            name: data.space?.name,
            dataClassificationTags: data.space?.dataClassificationTags,
            alias: data.space?.alias,
            homepage: data.space?.homepage,
            iconPath: data.space?.icon?.path,
            typeSettings: includeSpaceTypeSettings && data.space?.spaceTypeSettings ? {
                enabledContentTypes: {
                    ...data.space.spaceTypeSettings.enabledContentTypes
                }
            } : undefined
        } : undefined;
        $[16] = data;
        $[17] = includeSpaceTypeSettings;
        $[18] = t8;
    } else t8 = $[18];
    let t9;
    if ($[19] !== error || $[20] !== loading || $[21] !== t8) {
        t9 = {
            loading: loading,
            data: t8,
            error: error
        };
        $[19] = error;
        $[20] = loading;
        $[21] = t8;
        $[22] = t9;
    } else t9 = $[22];
    return t9;
};
module.exports["useSpaceDetail"] = $bbbfebced5e36727$export$7081570f83890156;

});

parcelRegister("6qkXi", function(module, exports) {

var $9wGTI = parcelRequire("9wGTI");


var $gKr8t = parcelRequire("gKr8t");

const $26379cee560cb131$export$4b3c44afb1a70b38 = ({ cloudId: cloudId, locale: locale, moduleType: moduleType, queryOptions: queryOptions, includeHidden: includeHidden, spaceKey: spaceKey, contentId: contentId, attachmentId: attachmentId, spaceContextOnly: spaceContextOnly = false })=>{
    const context = spaceContextOnly ? {
        spaceKey: spaceKey
    } : {
        spaceKey: spaceKey,
        contentId: contentId,
        // oxlint-disable-next-line confluence-feature-gating/no-new-feature-gates
        ...attachmentId && (0, $9wGTI.fg)('forge_attachment_display_conditions') ? {
            attachmentId: attachmentId
        } : {}
    };
    const options = {
        client: (0, $gKr8t.getAGGClient)(),
        cloudId: cloudId,
        types: [
            moduleType
        ],
        queryOptions: {
            ...queryOptions
        },
        locale: locale,
        context: context,
        includeHidden: includeHidden
    };
    return options;
};
module.exports["getUsePrefilteredExtensionListOptions"] = $26379cee560cb131$export$4b3c44afb1a70b38;

});

parcelRegister("9gIPO", function(module, exports) {
/** Read only an explicit tenant entry; an absent or malformed entry reserves nothing. */ const $86b3b2ddf5ae0125$export$517bca7c7f206860 = (serializedConfig, cloudId, extensions)=>{
    if (!extensions.some((extension)=>extension.id?.endsWith('/mantra-navigation'))) return 0;
    return $86b3b2ddf5ae0125$export$54a57a26f4c6d99e(serializedConfig, cloudId);
};
const $86b3b2ddf5ae0125$export$54a57a26f4c6d99e = (serializedConfig, cloudId)=>{
    try {
        const config = JSON.parse(serializedConfig);
        if (!config || typeof config !== 'object' || Array.isArray(config)) return 0;
        const height = Object.prototype.hasOwnProperty.call(config, cloudId) ? config[cloudId] : undefined;
        return typeof height === 'number' && Number.isFinite(height) && height > 0 && height <= 200 ? height : 0;
    } catch  {
        return 0;
    }
};
module.exports["getMantraNavigationHeight"] = $86b3b2ddf5ae0125$export$517bca7c7f206860;

});

parcelRegister("1jwVN", function(module, exports) {

var $1xpoY = parcelRequire("1xpoY");

const $652ac6dfc3a3ab78$export$5da04ccd64a4608f = {
    presetHeight: 0,
    removalDelay: 100,
    maxDelay: 10000
};
const $652ac6dfc3a3ab78$export$c5279e7580e090db = ()=>{
    try {
        const config = JSON.parse((0, $1xpoY.default).getString('confluence_forge_banner_preset_height', ''));
        const { presetHeight: presetHeight, removalDelay: removalDelay = $652ac6dfc3a3ab78$export$5da04ccd64a4608f.removalDelay, maxDelay: maxDelay = $652ac6dfc3a3ab78$export$5da04ccd64a4608f.maxDelay } = config;
        if (typeof presetHeight !== 'number' || !Number.isFinite(presetHeight) || presetHeight < 0 || typeof removalDelay !== 'number' || !Number.isFinite(removalDelay) || removalDelay < 0 || typeof maxDelay !== 'number' || !Number.isFinite(maxDelay) || maxDelay < 0) return $652ac6dfc3a3ab78$export$5da04ccd64a4608f;
        return {
            presetHeight: presetHeight,
            removalDelay: removalDelay,
            maxDelay: maxDelay
        };
    } catch  {
        return $652ac6dfc3a3ab78$export$5da04ccd64a4608f;
    }
};
module.exports["DEFAULT_FORGE_BANNER_PRESET_HEIGHT_CONFIG"] = $652ac6dfc3a3ab78$export$5da04ccd64a4608f;
module.exports["getForgeBannerPresetHeightConfig"] = $652ac6dfc3a3ab78$export$c5279e7580e090db;

});

parcelRegister("4NX9d", function(module, exports) {

var $6b4nE = parcelRequire("6b4nE");


var $cozmU = parcelRequire("cozmU");


var $9eE57 = parcelRequire("9eE57");

class $6182ff2f7ce21920$export$c7a09306845216e0 extends (0, $cozmU.Component) {
    componentDidMount() {
        (0, $9eE57.perfMarkEnd)(this.props);
    }
    render() {
        return null;
    }
}
$6182ff2f7ce21920$export$c7a09306845216e0.propTypes = {
    subject: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).string.isRequired,
    subjectId: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).string,
    details: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).object,
    includeFeatureFlags: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).bool
};
$6182ff2f7ce21920$export$c7a09306845216e0.defaultProps = {
    subjectId: '',
    includeFeatureFlags: false
};
module.exports["PerformanceEnd"] = $6182ff2f7ce21920$export$c7a09306845216e0;

});

parcelRegister("6yagU", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $3Ap09 = parcelRequire("3Ap09");


var $dAzRS = parcelRequire("dAzRS");


var $9iW1B = parcelRequire("9iW1B");


var $8wJwv = parcelRequire("8wJwv");

// Component that uses the URL change detection hooks inside the provider context
const $8e2f4c2c3b316f28$var$UrlChangeDetector = (0, $3u0dr.isReactCompilerActiveV2)() ? ()=>{
    (0, $9iW1B.useClosePreviewPanelOnUrlChange)();
    return null;
} : ()=>{
    (0, $9iW1B.useClosePreviewPanelOnUrlChange)();
    return null; // This component doesn't render anything
};
const $8e2f4c2c3b316f28$export$2b37b625358608ab = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(9);
    const { children: children } = t0;
    const { closeAllPanels: closeAllPanels, closeOnlyPreviewPanel: closeOnlyPreviewPanel } = (0, $8wJwv.useClosePreviewPanel)();
    let t1;
    if ($[0] !== closeAllPanels) {
        t1 = ()=>{
            closeAllPanels();
        };
        $[0] = closeAllPanels;
        $[1] = t1;
    } else t1 = $[1];
    const onPreviewPanelOpen = t1;
    let t2;
    if ($[2] !== closeOnlyPreviewPanel) {
        t2 = ()=>{
            closeOnlyPreviewPanel();
        };
        $[2] = closeOnlyPreviewPanel;
        $[3] = t2;
    } else t2 = $[3];
    const onPreviewPanelClose = t2;
    let t3;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($8e2f4c2c3b316f28$var$UrlChangeDetector, null);
        $[4] = t3;
    } else t3 = $[4];
    let t4;
    if ($[5] !== children || $[6] !== onPreviewPanelClose || $[7] !== onPreviewPanelOpen) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3Ap09.PreviewPanelsProvider), {
            onPreviewPanelOpen: onPreviewPanelOpen,
            onPreviewPanelClose: onPreviewPanelClose,
            parentProduct: (0, $dAzRS.PARENT_PRODUCTS).CONFLUENCE
        }, t3, children);
        $[5] = children;
        $[6] = onPreviewPanelClose;
        $[7] = onPreviewPanelOpen;
        $[8] = t4;
    } else t4 = $[8];
    return t4;
} : ({ children: children })=>{
    const { closeAllPanels: closeAllPanels, closeOnlyPreviewPanel: closeOnlyPreviewPanel } = (0, $8wJwv.useClosePreviewPanel)();
    const onPreviewPanelOpen = (0, $cozmU.useCallback)(()=>{
        /*
    Any time a Preview Panel is opened in Confluence, we want to close all
    non-preview panel side panels (like the object sidebar) to ensure no panel conflicts.
    */ closeAllPanels();
    }, [
        closeAllPanels
    ]);
    const onPreviewPanelClose = (0, $cozmU.useCallback)(()=>{
        // Add any additional logic here for closing preview panels.
        /*
    	Any time a Preview Panel is closed in Confluence, if the type of the previous panel and the
    	next panel are different, we want to close the previous panel before opening the new one. In order to
    	do this we need to pass the preview panel api
    */ closeOnlyPreviewPanel();
    }, [
        closeOnlyPreviewPanel
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3Ap09.PreviewPanelsProvider), {
        onPreviewPanelOpen: onPreviewPanelOpen,
        onPreviewPanelClose: onPreviewPanelClose,
        parentProduct: (0, $dAzRS.PARENT_PRODUCTS).CONFLUENCE
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($8e2f4c2c3b316f28$var$UrlChangeDetector, null), children);
};
module.exports["ConfluencePreviewPanelsProvider"] = $8e2f4c2c3b316f28$export$2b37b625358608ab;

});

parcelRegister("9iW1B", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $KDAt0 = parcelRequire("KDAt0");


var $8wJwv = parcelRequire("8wJwv");

const $eebfdbee6f102beb$export$d9ff7c1a1cd87d12 = (0, $3u0dr.isReactCompilerActiveV2)() ? ()=>{
    const $ = (0, $bDgLe.c)(4);
    const { closeOnlyPreviewPanel: closeOnlyPreviewPanel } = (0, $8wJwv.useClosePreviewPanel)();
    const location = (0, $KDAt0.useLocation)();
    const previousLocation = (0, $cozmU.useRef)(location);
    let t0;
    let t1;
    if ($[0] !== closeOnlyPreviewPanel || $[1] !== location) {
        t0 = ()=>{
            const currentLocationKey = `${location.pathname}${location.search}`;
            const previousLocationKey = `${previousLocation.current.pathname}${previousLocation.current.search}`;
            if (currentLocationKey !== previousLocationKey) {
                closeOnlyPreviewPanel();
                previousLocation.current = location;
            }
        };
        t1 = [
            location,
            closeOnlyPreviewPanel
        ];
        $[0] = closeOnlyPreviewPanel;
        $[1] = location;
        $[2] = t0;
        $[3] = t1;
    } else {
        t0 = $[2];
        t1 = $[3];
    }
    (0, $cozmU.useEffect)(t0, t1);
} : ()=>{
    const { closeOnlyPreviewPanel: closeOnlyPreviewPanel } = (0, $8wJwv.useClosePreviewPanel)();
    const location = (0, $KDAt0.useLocation)();
    const previousLocation = (0, $cozmU.useRef)(location);
    (0, $cozmU.useEffect)(()=>{
        // Check if location has actually changed (excluding hash for same-page navigation)
        const currentLocationKey = `${location.pathname}${location.search}`;
        const previousLocationKey = `${previousLocation.current.pathname}${previousLocation.current.search}`;
        if (currentLocationKey !== previousLocationKey) {
            // closeOnlyPreviewPanel already includes the check for open panels
            closeOnlyPreviewPanel();
            // Update the previous location reference
            previousLocation.current = location;
        }
    }, [
        location,
        closeOnlyPreviewPanel
    ]);
};
module.exports["useClosePreviewPanelOnUrlChange"] = $eebfdbee6f102beb$export$d9ff7c1a1cd87d12;

});

parcelRegister("8wJwv", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $lRhY3 = parcelRequire("lRhY3");


var $3Ap09 = parcelRequire("3Ap09");


var $jln20 = parcelRequire("jln20");


var $aWwYt = parcelRequire("aWwYt");

const $973f6037ca005097$export$aedf9e3a5c7d9cd = (0, $3u0dr.isReactCompilerActiveV2)() ? ()=>{
    const $ = (0, $bDgLe.c)(11);
    const context = (0, $3Ap09.usePreviewPanelsContext)();
    const { hideObjectSidebar: hideObjectSidebar } = (0, $aWwYt.useObjectSidebarActions)();
    const { close: close } = (0, $lRhY3.usePreviewPanelsActions)();
    const { closeAll: closeAll } = (0, $jln20.useRightSidebarContext)();
    let t0;
    if ($[0] !== hideObjectSidebar) {
        t0 = ()=>{
            window.dispatchEvent(new Event("closeGlobalSidebar"));
            hideObjectSidebar();
        };
        $[0] = hideObjectSidebar;
        $[1] = t0;
    } else t0 = $[1];
    const closeObjectSidebar = t0;
    let t1;
    if ($[2] !== close || $[3] !== context?.state?.panel) {
        t1 = (onClose)=>{
            if (context?.state?.panel) close(onClose);
        };
        $[2] = close;
        $[3] = context?.state?.panel;
        $[4] = t1;
    } else t1 = $[4];
    const closeOnlyPreviewPanel = t1;
    let t2;
    if ($[5] !== closeAll || $[6] !== closeObjectSidebar) {
        t2 = ()=>{
            closeAll();
            closeObjectSidebar();
        };
        $[5] = closeAll;
        $[6] = closeObjectSidebar;
        $[7] = t2;
    } else t2 = $[7];
    const closeAllPanels = t2;
    let t3;
    if ($[8] !== closeAllPanels || $[9] !== closeOnlyPreviewPanel) {
        t3 = {
            closeAllPanels: closeAllPanels,
            closeOnlyPreviewPanel: closeOnlyPreviewPanel
        };
        $[8] = closeAllPanels;
        $[9] = closeOnlyPreviewPanel;
        $[10] = t3;
    } else t3 = $[10];
    return t3;
} : ()=>{
    const context = (0, $3Ap09.usePreviewPanelsContext)();
    const { hideObjectSidebar: hideObjectSidebar } = (0, $aWwYt.useObjectSidebarActions)();
    const { close: close } = (0, $lRhY3.usePreviewPanelsActions)();
    const { closeAll: closeAll } = (0, $jln20.useRightSidebarContext)();
    const closeObjectSidebar = ()=>{
        window.dispatchEvent(new Event('closeGlobalSidebar'));
        hideObjectSidebar();
    };
    const closeOnlyPreviewPanel = (onClose)=>{
        if (context?.state?.panel) close(onClose);
    };
    const closeAllPanels = ()=>{
        closeAll();
        closeObjectSidebar();
    };
    return {
        closeAllPanels: closeAllPanels,
        closeOnlyPreviewPanel: closeOnlyPreviewPanel
    };
};
module.exports["useClosePreviewPanel"] = $973f6037ca005097$export$aedf9e3a5c7d9cd;

});

parcelRegister("ln0hx", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $1kHsc = parcelRequire("1kHsc");

function $0c8ceb2bfbb43f95$export$f20b867e738a222c({ id: id, name: name, timeout: timeout, attributes: attributes, collect: collect, onSuccess: onSuccess }) {
    const experienceTracker = (0, $cozmU.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const wasCalledRef = (0, $cozmU.useRef)(false);
    if (!wasCalledRef.current) {
        experienceTracker.start({
            attributes: attributes,
            name: name,
            id: id,
            timeout: timeout,
            collect: collect,
            onSuccess: onSuccess
        });
        wasCalledRef.current = true;
    }
    return null;
}
module.exports["ExperienceStart"] = $0c8ceb2bfbb43f95$export$f20b867e738a222c;

});

parcelRegister("7QUD1", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $02976f123c8f8e25$export$1764bc361f317144 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "dQS92",
    name: "AttachmentActionForgeApp",
    loader: async ()=>(await (parcelRequire("6OR8n"))).AttachmentActionForgeApp
});

const $02976f123c8f8e25$export$d2159b9f3f077903 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "cPPBg",
    name: "ByLineForgeApp",
    loader: async ()=>(await (parcelRequire("5dVz4"))).ByLineForgeApp
});

const $02976f123c8f8e25$export$f900958ce7c4410f = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "uUYc7",
    name: "ContentActionForgeApp",
    loader: async ()=>(await (parcelRequire("kclyJ"))).ContentActionForgeApp
});

const $02976f123c8f8e25$export$79ed117743c6c2cf = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "YSsGA",
    name: "ContextMenuForgeApp",
    loader: async ()=>(await (parcelRequire("9AJ3U"))).ContextMenuForgeApp
});

const $02976f123c8f8e25$export$b8ad4f58faf0ae = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "AI3JE",
    name: "FullPageForgeApp",
    loader: async ()=>(await (parcelRequire("7dnj0"))).FullPageForgeApp
});

const $02976f123c8f8e25$export$83db8797814193a8 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "HPVuo",
    name: "GlobalPageForgeApp",
    loader: async ()=>(await (parcelRequire("ix8Gk"))).GlobalPageForgeApp
});

const $02976f123c8f8e25$export$74528162c4c3828b = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "iEsk7",
    name: "GlobalSettingsForgeApp",
    loader: async ()=>(await (parcelRequire("hL0LE"))).GlobalSettingsForgeApp
});

const $02976f123c8f8e25$export$c8291e2d6d6adbf2 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "MWvHM",
    name: "HomepageFeedForgeApp",
    loader: async ()=>(await (parcelRequire("dhgqa"))).HomepageFeedForgeApp
});

const $02976f123c8f8e25$export$e8858129e933f7e8 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "KHgoO",
    name: "SpaceSettingsForgeApp",
    loader: async ()=>(await (parcelRequire("4oWQf"))).SpaceSettingsForgeApp
});

const $02976f123c8f8e25$export$60a905140138a1c8 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "-3RXI",
    name: "SpacePageForgeApp",
    loader: async ()=>(await (parcelRequire("2qNvl"))).SpacePageForgeApp
});

const $02976f123c8f8e25$export$578d0cbdb0ffa72e = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "9Auod",
    name: "CustomContentForgeApp",
    loader: async ()=>(await (parcelRequire("i5J3G"))).CustomContentForgeApp
});

const $02976f123c8f8e25$export$40d4b5cfa6c18ea7 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "zkdSh",
    name: "BackgroundScriptForgeApp",
    loader: async ()=>(await (parcelRequire("6wy4M"))).BackgroundScriptForgeApp
});

const $02976f123c8f8e25$export$c76787f94e0b1609 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "BA7en",
    name: "PageBannerForgeApp",
    loader: async ()=>(await (parcelRequire("1tSr5"))).PageBannerForgeApp
});
module.exports["AttachmentActionForgeApp"] = $02976f123c8f8e25$export$1764bc361f317144;
module.exports["ByLineForgeApp"] = $02976f123c8f8e25$export$d2159b9f3f077903;
module.exports["ContentActionForgeApp"] = $02976f123c8f8e25$export$f900958ce7c4410f;
module.exports["ContextMenuForgeApp"] = $02976f123c8f8e25$export$79ed117743c6c2cf;
module.exports["GlobalPageForgeApp"] = $02976f123c8f8e25$export$83db8797814193a8;
module.exports["GlobalSettingsForgeApp"] = $02976f123c8f8e25$export$74528162c4c3828b;
module.exports["HomepageFeedForgeApp"] = $02976f123c8f8e25$export$c8291e2d6d6adbf2;
module.exports["SpaceSettingsForgeApp"] = $02976f123c8f8e25$export$e8858129e933f7e8;
module.exports["SpacePageForgeApp"] = $02976f123c8f8e25$export$60a905140138a1c8;
module.exports["CustomContentForgeApp"] = $02976f123c8f8e25$export$578d0cbdb0ffa72e;
module.exports["BackgroundScriptForgeApp"] = $02976f123c8f8e25$export$40d4b5cfa6c18ea7;
module.exports["PageBannerForgeApp"] = $02976f123c8f8e25$export$c76787f94e0b1609;

});

parcelRegister("6OR8n", function(module, exports) {

let $4f70a0f0d8e13736$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $4f70a0f0d8e13736$var$load("hUbK8"),
    $4f70a0f0d8e13736$var$load("LWh5V"),
    $4f70a0f0d8e13736$var$load("eRlPy"),
    $4f70a0f0d8e13736$var$load("3eyRH"),
    $4f70a0f0d8e13736$var$load("3Whaz"),
    $4f70a0f0d8e13736$var$load("b6eef"),
    $4f70a0f0d8e13736$var$load("1Gr4q"),
    $4f70a0f0d8e13736$var$load("esBxc"),
    $4f70a0f0d8e13736$var$load("3pbEq"),
    $4f70a0f0d8e13736$var$load("9cVML"),
    $4f70a0f0d8e13736$var$load("7G12e"),
    $4f70a0f0d8e13736$var$load("4938u"),
    $4f70a0f0d8e13736$var$load("15jTz"),
    $4f70a0f0d8e13736$var$load("48F3z"),
    $4f70a0f0d8e13736$var$load("7SteV"),
    $4f70a0f0d8e13736$var$load("9LJFK"),
    $4f70a0f0d8e13736$var$load("d66hN"),
    $4f70a0f0d8e13736$var$load("dxA9F"),
    $4f70a0f0d8e13736$var$load("bkMxV"),
    $4f70a0f0d8e13736$var$load("aRCaA"),
    $4f70a0f0d8e13736$var$load("h3Rq9"),
    $4f70a0f0d8e13736$var$load("iZR3N"),
    $4f70a0f0d8e13736$var$load("jXM1T"),
    $4f70a0f0d8e13736$var$load("cvcNg"),
    $4f70a0f0d8e13736$var$load("4N1MY"),
    $4f70a0f0d8e13736$var$load("5MQ0D"),
    $4f70a0f0d8e13736$var$load("i7NGK"),
    $4f70a0f0d8e13736$var$load("cIoRg"),
    $4f70a0f0d8e13736$var$load("g7vSH"),
    $4f70a0f0d8e13736$var$load("jL1Ke"),
    $4f70a0f0d8e13736$var$load("fuOfV"),
    $4f70a0f0d8e13736$var$load("kHXvF"),
    $4f70a0f0d8e13736$var$load("ea3NB"),
    $4f70a0f0d8e13736$var$load("6wr18"),
    $4f70a0f0d8e13736$var$load("ffEVr"),
    $4f70a0f0d8e13736$var$load("59hV4"),
    $4f70a0f0d8e13736$var$load("l4j2l"),
    $4f70a0f0d8e13736$var$load("37v60"),
    $4f70a0f0d8e13736$var$load("cGkFm"),
    $4f70a0f0d8e13736$var$load("eF92L"),
    $4f70a0f0d8e13736$var$load("jwMHX"),
    $4f70a0f0d8e13736$var$load("20wSi"),
    $4f70a0f0d8e13736$var$load("bmOOW"),
    $4f70a0f0d8e13736$var$load("dDiWc"),
    $4f70a0f0d8e13736$var$load("d0ZRF"),
    $4f70a0f0d8e13736$var$load("k507P"),
    $4f70a0f0d8e13736$var$load("fwbNS"),
    $4f70a0f0d8e13736$var$load("gaUhx"),
    $4f70a0f0d8e13736$var$load("h4Nf7"),
    $4f70a0f0d8e13736$var$load("9TOep"),
    $4f70a0f0d8e13736$var$load("bncmK"),
    $4f70a0f0d8e13736$var$load("6iTkp"),
    $4f70a0f0d8e13736$var$load("hhss7"),
    $4f70a0f0d8e13736$var$load("a8R25"),
    $4f70a0f0d8e13736$var$load("lnKog"),
    $4f70a0f0d8e13736$var$load("aAWLw"),
    $4f70a0f0d8e13736$var$load("7EorR"),
    $4f70a0f0d8e13736$var$load("fJ8Kj")
]).then(()=>parcelRequire('2L9yO'));

});

parcelRegister("5dVz4", function(module, exports) {

let $3cdad1ce47f0321a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $3cdad1ce47f0321a$var$load("hUbK8"),
    $3cdad1ce47f0321a$var$load("LWh5V"),
    $3cdad1ce47f0321a$var$load("eRlPy"),
    $3cdad1ce47f0321a$var$load("3eyRH"),
    $3cdad1ce47f0321a$var$load("3Whaz"),
    $3cdad1ce47f0321a$var$load("b6eef"),
    $3cdad1ce47f0321a$var$load("1Gr4q"),
    $3cdad1ce47f0321a$var$load("esBxc"),
    $3cdad1ce47f0321a$var$load("3pbEq"),
    $3cdad1ce47f0321a$var$load("9cVML"),
    $3cdad1ce47f0321a$var$load("7G12e"),
    $3cdad1ce47f0321a$var$load("4938u"),
    $3cdad1ce47f0321a$var$load("15jTz"),
    $3cdad1ce47f0321a$var$load("48F3z"),
    $3cdad1ce47f0321a$var$load("7SteV"),
    $3cdad1ce47f0321a$var$load("9LJFK"),
    $3cdad1ce47f0321a$var$load("d66hN"),
    $3cdad1ce47f0321a$var$load("dxA9F"),
    $3cdad1ce47f0321a$var$load("bkMxV"),
    $3cdad1ce47f0321a$var$load("aRCaA"),
    $3cdad1ce47f0321a$var$load("h3Rq9"),
    $3cdad1ce47f0321a$var$load("iZR3N"),
    $3cdad1ce47f0321a$var$load("jXM1T"),
    $3cdad1ce47f0321a$var$load("cvcNg"),
    $3cdad1ce47f0321a$var$load("4N1MY"),
    $3cdad1ce47f0321a$var$load("5MQ0D"),
    $3cdad1ce47f0321a$var$load("i7NGK"),
    $3cdad1ce47f0321a$var$load("cIoRg"),
    $3cdad1ce47f0321a$var$load("g7vSH"),
    $3cdad1ce47f0321a$var$load("jL1Ke"),
    $3cdad1ce47f0321a$var$load("fuOfV"),
    $3cdad1ce47f0321a$var$load("kHXvF"),
    $3cdad1ce47f0321a$var$load("ea3NB"),
    $3cdad1ce47f0321a$var$load("6wr18"),
    $3cdad1ce47f0321a$var$load("ffEVr"),
    $3cdad1ce47f0321a$var$load("59hV4"),
    $3cdad1ce47f0321a$var$load("l4j2l"),
    $3cdad1ce47f0321a$var$load("37v60"),
    $3cdad1ce47f0321a$var$load("cGkFm"),
    $3cdad1ce47f0321a$var$load("eF92L"),
    $3cdad1ce47f0321a$var$load("jwMHX"),
    $3cdad1ce47f0321a$var$load("20wSi"),
    $3cdad1ce47f0321a$var$load("bmOOW"),
    $3cdad1ce47f0321a$var$load("dDiWc"),
    $3cdad1ce47f0321a$var$load("d0ZRF"),
    $3cdad1ce47f0321a$var$load("k507P"),
    $3cdad1ce47f0321a$var$load("fwbNS"),
    $3cdad1ce47f0321a$var$load("gaUhx"),
    $3cdad1ce47f0321a$var$load("h4Nf7"),
    $3cdad1ce47f0321a$var$load("9TOep"),
    $3cdad1ce47f0321a$var$load("bncmK"),
    $3cdad1ce47f0321a$var$load("6iTkp"),
    $3cdad1ce47f0321a$var$load("hhss7"),
    $3cdad1ce47f0321a$var$load("a8R25"),
    $3cdad1ce47f0321a$var$load("lnKog"),
    $3cdad1ce47f0321a$var$load("aAWLw"),
    $3cdad1ce47f0321a$var$load("7EorR"),
    $3cdad1ce47f0321a$var$load("bGzhS")
]).then(()=>parcelRequire('5soYL'));

});

parcelRegister("kclyJ", function(module, exports) {

let $eb45a6d8ee576b19$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $eb45a6d8ee576b19$var$load("hUbK8"),
    $eb45a6d8ee576b19$var$load("LWh5V"),
    $eb45a6d8ee576b19$var$load("eRlPy"),
    $eb45a6d8ee576b19$var$load("3eyRH"),
    $eb45a6d8ee576b19$var$load("3Whaz"),
    $eb45a6d8ee576b19$var$load("b6eef"),
    $eb45a6d8ee576b19$var$load("1Gr4q"),
    $eb45a6d8ee576b19$var$load("esBxc"),
    $eb45a6d8ee576b19$var$load("3pbEq"),
    $eb45a6d8ee576b19$var$load("9cVML"),
    $eb45a6d8ee576b19$var$load("7G12e"),
    $eb45a6d8ee576b19$var$load("4938u"),
    $eb45a6d8ee576b19$var$load("15jTz"),
    $eb45a6d8ee576b19$var$load("48F3z"),
    $eb45a6d8ee576b19$var$load("7SteV"),
    $eb45a6d8ee576b19$var$load("9LJFK"),
    $eb45a6d8ee576b19$var$load("d66hN"),
    $eb45a6d8ee576b19$var$load("dxA9F"),
    $eb45a6d8ee576b19$var$load("bkMxV"),
    $eb45a6d8ee576b19$var$load("aRCaA"),
    $eb45a6d8ee576b19$var$load("h3Rq9"),
    $eb45a6d8ee576b19$var$load("iZR3N"),
    $eb45a6d8ee576b19$var$load("jXM1T"),
    $eb45a6d8ee576b19$var$load("cvcNg"),
    $eb45a6d8ee576b19$var$load("4N1MY"),
    $eb45a6d8ee576b19$var$load("5MQ0D"),
    $eb45a6d8ee576b19$var$load("i7NGK"),
    $eb45a6d8ee576b19$var$load("cIoRg"),
    $eb45a6d8ee576b19$var$load("g7vSH"),
    $eb45a6d8ee576b19$var$load("jL1Ke"),
    $eb45a6d8ee576b19$var$load("fuOfV"),
    $eb45a6d8ee576b19$var$load("kHXvF"),
    $eb45a6d8ee576b19$var$load("ea3NB"),
    $eb45a6d8ee576b19$var$load("6wr18"),
    $eb45a6d8ee576b19$var$load("ffEVr"),
    $eb45a6d8ee576b19$var$load("59hV4"),
    $eb45a6d8ee576b19$var$load("l4j2l"),
    $eb45a6d8ee576b19$var$load("37v60"),
    $eb45a6d8ee576b19$var$load("cGkFm"),
    $eb45a6d8ee576b19$var$load("eF92L"),
    $eb45a6d8ee576b19$var$load("jwMHX"),
    $eb45a6d8ee576b19$var$load("20wSi"),
    $eb45a6d8ee576b19$var$load("bmOOW"),
    $eb45a6d8ee576b19$var$load("dDiWc"),
    $eb45a6d8ee576b19$var$load("d0ZRF"),
    $eb45a6d8ee576b19$var$load("k507P"),
    $eb45a6d8ee576b19$var$load("fwbNS"),
    $eb45a6d8ee576b19$var$load("gaUhx"),
    $eb45a6d8ee576b19$var$load("h4Nf7"),
    $eb45a6d8ee576b19$var$load("9TOep"),
    $eb45a6d8ee576b19$var$load("bncmK"),
    $eb45a6d8ee576b19$var$load("6iTkp"),
    $eb45a6d8ee576b19$var$load("hhss7"),
    $eb45a6d8ee576b19$var$load("a8R25"),
    $eb45a6d8ee576b19$var$load("lnKog"),
    $eb45a6d8ee576b19$var$load("aAWLw"),
    $eb45a6d8ee576b19$var$load("7EorR"),
    $eb45a6d8ee576b19$var$load("bdzih")
]).then(()=>parcelRequire('kXBs1'));

});

parcelRegister("9AJ3U", function(module, exports) {

let $6fba6e41479a1331$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $6fba6e41479a1331$var$load("hUbK8"),
    $6fba6e41479a1331$var$load("LWh5V"),
    $6fba6e41479a1331$var$load("eRlPy"),
    $6fba6e41479a1331$var$load("3eyRH"),
    $6fba6e41479a1331$var$load("3Whaz"),
    $6fba6e41479a1331$var$load("b6eef"),
    $6fba6e41479a1331$var$load("1Gr4q"),
    $6fba6e41479a1331$var$load("esBxc"),
    $6fba6e41479a1331$var$load("3pbEq"),
    $6fba6e41479a1331$var$load("9cVML"),
    $6fba6e41479a1331$var$load("7G12e"),
    $6fba6e41479a1331$var$load("4938u"),
    $6fba6e41479a1331$var$load("15jTz"),
    $6fba6e41479a1331$var$load("48F3z"),
    $6fba6e41479a1331$var$load("7SteV"),
    $6fba6e41479a1331$var$load("9LJFK"),
    $6fba6e41479a1331$var$load("d66hN"),
    $6fba6e41479a1331$var$load("dxA9F"),
    $6fba6e41479a1331$var$load("bkMxV"),
    $6fba6e41479a1331$var$load("aRCaA"),
    $6fba6e41479a1331$var$load("h3Rq9"),
    $6fba6e41479a1331$var$load("iZR3N"),
    $6fba6e41479a1331$var$load("jXM1T"),
    $6fba6e41479a1331$var$load("cvcNg"),
    $6fba6e41479a1331$var$load("4N1MY"),
    $6fba6e41479a1331$var$load("5MQ0D"),
    $6fba6e41479a1331$var$load("i7NGK"),
    $6fba6e41479a1331$var$load("cIoRg"),
    $6fba6e41479a1331$var$load("g7vSH"),
    $6fba6e41479a1331$var$load("jL1Ke"),
    $6fba6e41479a1331$var$load("fuOfV"),
    $6fba6e41479a1331$var$load("kHXvF"),
    $6fba6e41479a1331$var$load("ea3NB"),
    $6fba6e41479a1331$var$load("6wr18"),
    $6fba6e41479a1331$var$load("ffEVr"),
    $6fba6e41479a1331$var$load("59hV4"),
    $6fba6e41479a1331$var$load("l4j2l"),
    $6fba6e41479a1331$var$load("37v60"),
    $6fba6e41479a1331$var$load("cGkFm"),
    $6fba6e41479a1331$var$load("eF92L"),
    $6fba6e41479a1331$var$load("jwMHX"),
    $6fba6e41479a1331$var$load("20wSi"),
    $6fba6e41479a1331$var$load("bmOOW"),
    $6fba6e41479a1331$var$load("dDiWc"),
    $6fba6e41479a1331$var$load("d0ZRF"),
    $6fba6e41479a1331$var$load("k507P"),
    $6fba6e41479a1331$var$load("fwbNS"),
    $6fba6e41479a1331$var$load("gaUhx"),
    $6fba6e41479a1331$var$load("h4Nf7"),
    $6fba6e41479a1331$var$load("9TOep"),
    $6fba6e41479a1331$var$load("bncmK"),
    $6fba6e41479a1331$var$load("6iTkp"),
    $6fba6e41479a1331$var$load("hhss7"),
    $6fba6e41479a1331$var$load("a8R25"),
    $6fba6e41479a1331$var$load("lnKog"),
    $6fba6e41479a1331$var$load("aAWLw"),
    $6fba6e41479a1331$var$load("7EorR"),
    $6fba6e41479a1331$var$load("cwpVK")
]).then(()=>parcelRequire('1yxl3'));

});

parcelRegister("7dnj0", function(module, exports) {

let $540bd34f38e5c82d$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $540bd34f38e5c82d$var$load("d0ZRF"),
    $540bd34f38e5c82d$var$load("k507P"),
    $540bd34f38e5c82d$var$load("hUbK8"),
    $540bd34f38e5c82d$var$load("b6eef"),
    $540bd34f38e5c82d$var$load("1Gr4q"),
    $540bd34f38e5c82d$var$load("esBxc"),
    $540bd34f38e5c82d$var$load("3pbEq"),
    $540bd34f38e5c82d$var$load("9cVML"),
    $540bd34f38e5c82d$var$load("7G12e"),
    $540bd34f38e5c82d$var$load("4938u"),
    $540bd34f38e5c82d$var$load("7SteV"),
    $540bd34f38e5c82d$var$load("9LJFK"),
    $540bd34f38e5c82d$var$load("d66hN"),
    $540bd34f38e5c82d$var$load("dxA9F"),
    $540bd34f38e5c82d$var$load("bkMxV"),
    $540bd34f38e5c82d$var$load("aRCaA"),
    $540bd34f38e5c82d$var$load("h3Rq9"),
    $540bd34f38e5c82d$var$load("iZR3N"),
    $540bd34f38e5c82d$var$load("jXM1T"),
    $540bd34f38e5c82d$var$load("cvcNg"),
    $540bd34f38e5c82d$var$load("6wr18"),
    $540bd34f38e5c82d$var$load("4N1MY"),
    $540bd34f38e5c82d$var$load("i7NGK"),
    $540bd34f38e5c82d$var$load("kHXvF"),
    $540bd34f38e5c82d$var$load("ea3NB"),
    $540bd34f38e5c82d$var$load("ffEVr"),
    $540bd34f38e5c82d$var$load("l4j2l"),
    $540bd34f38e5c82d$var$load("37v60"),
    $540bd34f38e5c82d$var$load("cGkFm"),
    $540bd34f38e5c82d$var$load("eF92L"),
    $540bd34f38e5c82d$var$load("jwMHX"),
    $540bd34f38e5c82d$var$load("20wSi"),
    $540bd34f38e5c82d$var$load("bmOOW"),
    $540bd34f38e5c82d$var$load("dDiWc"),
    $540bd34f38e5c82d$var$load("a8R25"),
    $540bd34f38e5c82d$var$load("gaUhx"),
    $540bd34f38e5c82d$var$load("h4Nf7"),
    $540bd34f38e5c82d$var$load("9TOep"),
    $540bd34f38e5c82d$var$load("bncmK"),
    $540bd34f38e5c82d$var$load("6iTkp"),
    $540bd34f38e5c82d$var$load("hhss7"),
    $540bd34f38e5c82d$var$load("aAWLw"),
    $540bd34f38e5c82d$var$load("7EorR"),
    $540bd34f38e5c82d$var$load("68RC4")
]).then(()=>parcelRequire('f6dwD'));

});

parcelRegister("ix8Gk", function(module, exports) {

let $d7e20b122c0a948c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $d7e20b122c0a948c$var$load("d0ZRF"),
    $d7e20b122c0a948c$var$load("k507P"),
    $d7e20b122c0a948c$var$load("hUbK8"),
    $d7e20b122c0a948c$var$load("b6eef"),
    $d7e20b122c0a948c$var$load("1Gr4q"),
    $d7e20b122c0a948c$var$load("esBxc"),
    $d7e20b122c0a948c$var$load("3pbEq"),
    $d7e20b122c0a948c$var$load("9cVML"),
    $d7e20b122c0a948c$var$load("7G12e"),
    $d7e20b122c0a948c$var$load("4938u"),
    $d7e20b122c0a948c$var$load("7SteV"),
    $d7e20b122c0a948c$var$load("9LJFK"),
    $d7e20b122c0a948c$var$load("d66hN"),
    $d7e20b122c0a948c$var$load("dxA9F"),
    $d7e20b122c0a948c$var$load("bkMxV"),
    $d7e20b122c0a948c$var$load("aRCaA"),
    $d7e20b122c0a948c$var$load("h3Rq9"),
    $d7e20b122c0a948c$var$load("iZR3N"),
    $d7e20b122c0a948c$var$load("jXM1T"),
    $d7e20b122c0a948c$var$load("cvcNg"),
    $d7e20b122c0a948c$var$load("6wr18"),
    $d7e20b122c0a948c$var$load("4N1MY"),
    $d7e20b122c0a948c$var$load("i7NGK"),
    $d7e20b122c0a948c$var$load("kHXvF"),
    $d7e20b122c0a948c$var$load("ea3NB"),
    $d7e20b122c0a948c$var$load("ffEVr"),
    $d7e20b122c0a948c$var$load("l4j2l"),
    $d7e20b122c0a948c$var$load("37v60"),
    $d7e20b122c0a948c$var$load("cGkFm"),
    $d7e20b122c0a948c$var$load("eF92L"),
    $d7e20b122c0a948c$var$load("jwMHX"),
    $d7e20b122c0a948c$var$load("20wSi"),
    $d7e20b122c0a948c$var$load("bmOOW"),
    $d7e20b122c0a948c$var$load("dDiWc"),
    $d7e20b122c0a948c$var$load("a8R25"),
    $d7e20b122c0a948c$var$load("gaUhx"),
    $d7e20b122c0a948c$var$load("h4Nf7"),
    $d7e20b122c0a948c$var$load("9TOep"),
    $d7e20b122c0a948c$var$load("bncmK"),
    $d7e20b122c0a948c$var$load("6iTkp"),
    $d7e20b122c0a948c$var$load("hhss7"),
    $d7e20b122c0a948c$var$load("aAWLw"),
    $d7e20b122c0a948c$var$load("7EorR"),
    $d7e20b122c0a948c$var$load("87cDu")
]).then(()=>parcelRequire('iChZx'));

});

parcelRegister("hL0LE", function(module, exports) {

let $ced76be32337521d$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $ced76be32337521d$var$load("d0ZRF"),
    $ced76be32337521d$var$load("k507P"),
    $ced76be32337521d$var$load("hUbK8"),
    $ced76be32337521d$var$load("b6eef"),
    $ced76be32337521d$var$load("1Gr4q"),
    $ced76be32337521d$var$load("esBxc"),
    $ced76be32337521d$var$load("3pbEq"),
    $ced76be32337521d$var$load("9cVML"),
    $ced76be32337521d$var$load("7G12e"),
    $ced76be32337521d$var$load("4938u"),
    $ced76be32337521d$var$load("7SteV"),
    $ced76be32337521d$var$load("9LJFK"),
    $ced76be32337521d$var$load("d66hN"),
    $ced76be32337521d$var$load("dxA9F"),
    $ced76be32337521d$var$load("bkMxV"),
    $ced76be32337521d$var$load("aRCaA"),
    $ced76be32337521d$var$load("h3Rq9"),
    $ced76be32337521d$var$load("iZR3N"),
    $ced76be32337521d$var$load("jXM1T"),
    $ced76be32337521d$var$load("cvcNg"),
    $ced76be32337521d$var$load("6wr18"),
    $ced76be32337521d$var$load("4N1MY"),
    $ced76be32337521d$var$load("i7NGK"),
    $ced76be32337521d$var$load("kHXvF"),
    $ced76be32337521d$var$load("ea3NB"),
    $ced76be32337521d$var$load("ffEVr"),
    $ced76be32337521d$var$load("l4j2l"),
    $ced76be32337521d$var$load("37v60"),
    $ced76be32337521d$var$load("cGkFm"),
    $ced76be32337521d$var$load("eF92L"),
    $ced76be32337521d$var$load("jwMHX"),
    $ced76be32337521d$var$load("20wSi"),
    $ced76be32337521d$var$load("bmOOW"),
    $ced76be32337521d$var$load("dDiWc"),
    $ced76be32337521d$var$load("a8R25"),
    $ced76be32337521d$var$load("gaUhx"),
    $ced76be32337521d$var$load("h4Nf7"),
    $ced76be32337521d$var$load("9TOep"),
    $ced76be32337521d$var$load("bncmK"),
    $ced76be32337521d$var$load("6iTkp"),
    $ced76be32337521d$var$load("hhss7"),
    $ced76be32337521d$var$load("aAWLw"),
    $ced76be32337521d$var$load("7EorR"),
    $ced76be32337521d$var$load("iXr0W")
]).then(()=>parcelRequire('671JL'));

});

parcelRegister("dhgqa", function(module, exports) {

let $9aa999c8a7c5fcc9$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $9aa999c8a7c5fcc9$var$load("d0ZRF"),
    $9aa999c8a7c5fcc9$var$load("k507P"),
    $9aa999c8a7c5fcc9$var$load("hUbK8"),
    $9aa999c8a7c5fcc9$var$load("b6eef"),
    $9aa999c8a7c5fcc9$var$load("1Gr4q"),
    $9aa999c8a7c5fcc9$var$load("esBxc"),
    $9aa999c8a7c5fcc9$var$load("3pbEq"),
    $9aa999c8a7c5fcc9$var$load("9cVML"),
    $9aa999c8a7c5fcc9$var$load("7G12e"),
    $9aa999c8a7c5fcc9$var$load("4938u"),
    $9aa999c8a7c5fcc9$var$load("7SteV"),
    $9aa999c8a7c5fcc9$var$load("9LJFK"),
    $9aa999c8a7c5fcc9$var$load("d66hN"),
    $9aa999c8a7c5fcc9$var$load("dxA9F"),
    $9aa999c8a7c5fcc9$var$load("bkMxV"),
    $9aa999c8a7c5fcc9$var$load("aRCaA"),
    $9aa999c8a7c5fcc9$var$load("h3Rq9"),
    $9aa999c8a7c5fcc9$var$load("iZR3N"),
    $9aa999c8a7c5fcc9$var$load("jXM1T"),
    $9aa999c8a7c5fcc9$var$load("cvcNg"),
    $9aa999c8a7c5fcc9$var$load("6wr18"),
    $9aa999c8a7c5fcc9$var$load("4N1MY"),
    $9aa999c8a7c5fcc9$var$load("i7NGK"),
    $9aa999c8a7c5fcc9$var$load("kHXvF"),
    $9aa999c8a7c5fcc9$var$load("ea3NB"),
    $9aa999c8a7c5fcc9$var$load("ffEVr"),
    $9aa999c8a7c5fcc9$var$load("l4j2l"),
    $9aa999c8a7c5fcc9$var$load("37v60"),
    $9aa999c8a7c5fcc9$var$load("cGkFm"),
    $9aa999c8a7c5fcc9$var$load("eF92L"),
    $9aa999c8a7c5fcc9$var$load("jwMHX"),
    $9aa999c8a7c5fcc9$var$load("20wSi"),
    $9aa999c8a7c5fcc9$var$load("bmOOW"),
    $9aa999c8a7c5fcc9$var$load("dDiWc"),
    $9aa999c8a7c5fcc9$var$load("gaUhx"),
    $9aa999c8a7c5fcc9$var$load("h4Nf7"),
    $9aa999c8a7c5fcc9$var$load("9TOep"),
    $9aa999c8a7c5fcc9$var$load("bncmK"),
    $9aa999c8a7c5fcc9$var$load("6iTkp"),
    $9aa999c8a7c5fcc9$var$load("hhss7"),
    $9aa999c8a7c5fcc9$var$load("a8R25"),
    $9aa999c8a7c5fcc9$var$load("lnKog"),
    $9aa999c8a7c5fcc9$var$load("aAWLw"),
    $9aa999c8a7c5fcc9$var$load("7EorR"),
    $9aa999c8a7c5fcc9$var$load("ccJug")
]).then(()=>parcelRequire('k3MMo'));

});

parcelRegister("4oWQf", function(module, exports) {

let $33470c1029d79cf8$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $33470c1029d79cf8$var$load("hUbK8"),
    $33470c1029d79cf8$var$load("3eyRH"),
    $33470c1029d79cf8$var$load("3Whaz"),
    $33470c1029d79cf8$var$load("b6eef"),
    $33470c1029d79cf8$var$load("1Gr4q"),
    $33470c1029d79cf8$var$load("esBxc"),
    $33470c1029d79cf8$var$load("3pbEq"),
    $33470c1029d79cf8$var$load("9cVML"),
    $33470c1029d79cf8$var$load("7G12e"),
    $33470c1029d79cf8$var$load("4938u"),
    $33470c1029d79cf8$var$load("15jTz"),
    $33470c1029d79cf8$var$load("48F3z"),
    $33470c1029d79cf8$var$load("7SteV"),
    $33470c1029d79cf8$var$load("9LJFK"),
    $33470c1029d79cf8$var$load("d66hN"),
    $33470c1029d79cf8$var$load("dxA9F"),
    $33470c1029d79cf8$var$load("bkMxV"),
    $33470c1029d79cf8$var$load("aRCaA"),
    $33470c1029d79cf8$var$load("h3Rq9"),
    $33470c1029d79cf8$var$load("iZR3N"),
    $33470c1029d79cf8$var$load("jXM1T"),
    $33470c1029d79cf8$var$load("cvcNg"),
    $33470c1029d79cf8$var$load("4N1MY"),
    $33470c1029d79cf8$var$load("5MQ0D"),
    $33470c1029d79cf8$var$load("i7NGK"),
    $33470c1029d79cf8$var$load("cIoRg"),
    $33470c1029d79cf8$var$load("g7vSH"),
    $33470c1029d79cf8$var$load("jL1Ke"),
    $33470c1029d79cf8$var$load("fuOfV"),
    $33470c1029d79cf8$var$load("kHXvF"),
    $33470c1029d79cf8$var$load("ea3NB"),
    $33470c1029d79cf8$var$load("6wr18"),
    $33470c1029d79cf8$var$load("ffEVr"),
    $33470c1029d79cf8$var$load("59hV4"),
    $33470c1029d79cf8$var$load("l4j2l"),
    $33470c1029d79cf8$var$load("37v60"),
    $33470c1029d79cf8$var$load("cGkFm"),
    $33470c1029d79cf8$var$load("eF92L"),
    $33470c1029d79cf8$var$load("jwMHX"),
    $33470c1029d79cf8$var$load("20wSi"),
    $33470c1029d79cf8$var$load("bmOOW"),
    $33470c1029d79cf8$var$load("dDiWc"),
    $33470c1029d79cf8$var$load("d0ZRF"),
    $33470c1029d79cf8$var$load("k507P"),
    $33470c1029d79cf8$var$load("fwbNS"),
    $33470c1029d79cf8$var$load("gaUhx"),
    $33470c1029d79cf8$var$load("h4Nf7"),
    $33470c1029d79cf8$var$load("9TOep"),
    $33470c1029d79cf8$var$load("bncmK"),
    $33470c1029d79cf8$var$load("6iTkp"),
    $33470c1029d79cf8$var$load("hhss7"),
    $33470c1029d79cf8$var$load("a8R25"),
    $33470c1029d79cf8$var$load("lnKog"),
    $33470c1029d79cf8$var$load("aAWLw"),
    $33470c1029d79cf8$var$load("7EorR"),
    $33470c1029d79cf8$var$load("irYLY")
]).then(()=>parcelRequire('aeos9'));

});

parcelRegister("2qNvl", function(module, exports) {

let $1c5469092c8e48e4$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $1c5469092c8e48e4$var$load("hUbK8"),
    $1c5469092c8e48e4$var$load("3eyRH"),
    $1c5469092c8e48e4$var$load("3Whaz"),
    $1c5469092c8e48e4$var$load("b6eef"),
    $1c5469092c8e48e4$var$load("1Gr4q"),
    $1c5469092c8e48e4$var$load("esBxc"),
    $1c5469092c8e48e4$var$load("3pbEq"),
    $1c5469092c8e48e4$var$load("9cVML"),
    $1c5469092c8e48e4$var$load("7G12e"),
    $1c5469092c8e48e4$var$load("4938u"),
    $1c5469092c8e48e4$var$load("15jTz"),
    $1c5469092c8e48e4$var$load("48F3z"),
    $1c5469092c8e48e4$var$load("7SteV"),
    $1c5469092c8e48e4$var$load("9LJFK"),
    $1c5469092c8e48e4$var$load("d66hN"),
    $1c5469092c8e48e4$var$load("dxA9F"),
    $1c5469092c8e48e4$var$load("bkMxV"),
    $1c5469092c8e48e4$var$load("aRCaA"),
    $1c5469092c8e48e4$var$load("h3Rq9"),
    $1c5469092c8e48e4$var$load("iZR3N"),
    $1c5469092c8e48e4$var$load("jXM1T"),
    $1c5469092c8e48e4$var$load("cvcNg"),
    $1c5469092c8e48e4$var$load("4N1MY"),
    $1c5469092c8e48e4$var$load("5MQ0D"),
    $1c5469092c8e48e4$var$load("i7NGK"),
    $1c5469092c8e48e4$var$load("cIoRg"),
    $1c5469092c8e48e4$var$load("g7vSH"),
    $1c5469092c8e48e4$var$load("jL1Ke"),
    $1c5469092c8e48e4$var$load("fuOfV"),
    $1c5469092c8e48e4$var$load("kHXvF"),
    $1c5469092c8e48e4$var$load("ea3NB"),
    $1c5469092c8e48e4$var$load("6wr18"),
    $1c5469092c8e48e4$var$load("ffEVr"),
    $1c5469092c8e48e4$var$load("59hV4"),
    $1c5469092c8e48e4$var$load("l4j2l"),
    $1c5469092c8e48e4$var$load("37v60"),
    $1c5469092c8e48e4$var$load("cGkFm"),
    $1c5469092c8e48e4$var$load("eF92L"),
    $1c5469092c8e48e4$var$load("jwMHX"),
    $1c5469092c8e48e4$var$load("20wSi"),
    $1c5469092c8e48e4$var$load("bmOOW"),
    $1c5469092c8e48e4$var$load("dDiWc"),
    $1c5469092c8e48e4$var$load("d0ZRF"),
    $1c5469092c8e48e4$var$load("k507P"),
    $1c5469092c8e48e4$var$load("fwbNS"),
    $1c5469092c8e48e4$var$load("gaUhx"),
    $1c5469092c8e48e4$var$load("h4Nf7"),
    $1c5469092c8e48e4$var$load("9TOep"),
    $1c5469092c8e48e4$var$load("bncmK"),
    $1c5469092c8e48e4$var$load("6iTkp"),
    $1c5469092c8e48e4$var$load("hhss7"),
    $1c5469092c8e48e4$var$load("a8R25"),
    $1c5469092c8e48e4$var$load("lnKog"),
    $1c5469092c8e48e4$var$load("aAWLw"),
    $1c5469092c8e48e4$var$load("7EorR"),
    $1c5469092c8e48e4$var$load("ldtPf")
]).then(()=>parcelRequire('kWbxC'));

});

parcelRegister("i5J3G", function(module, exports) {

let $d2bba54c037d34e8$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $d2bba54c037d34e8$var$load("d0ZRF"),
    $d2bba54c037d34e8$var$load("k507P"),
    $d2bba54c037d34e8$var$load("hUbK8"),
    $d2bba54c037d34e8$var$load("b6eef"),
    $d2bba54c037d34e8$var$load("1Gr4q"),
    $d2bba54c037d34e8$var$load("esBxc"),
    $d2bba54c037d34e8$var$load("3pbEq"),
    $d2bba54c037d34e8$var$load("9cVML"),
    $d2bba54c037d34e8$var$load("7G12e"),
    $d2bba54c037d34e8$var$load("4938u"),
    $d2bba54c037d34e8$var$load("7SteV"),
    $d2bba54c037d34e8$var$load("9LJFK"),
    $d2bba54c037d34e8$var$load("d66hN"),
    $d2bba54c037d34e8$var$load("dxA9F"),
    $d2bba54c037d34e8$var$load("bkMxV"),
    $d2bba54c037d34e8$var$load("aRCaA"),
    $d2bba54c037d34e8$var$load("h3Rq9"),
    $d2bba54c037d34e8$var$load("iZR3N"),
    $d2bba54c037d34e8$var$load("jXM1T"),
    $d2bba54c037d34e8$var$load("cvcNg"),
    $d2bba54c037d34e8$var$load("6wr18"),
    $d2bba54c037d34e8$var$load("4N1MY"),
    $d2bba54c037d34e8$var$load("i7NGK"),
    $d2bba54c037d34e8$var$load("kHXvF"),
    $d2bba54c037d34e8$var$load("ea3NB"),
    $d2bba54c037d34e8$var$load("ffEVr"),
    $d2bba54c037d34e8$var$load("l4j2l"),
    $d2bba54c037d34e8$var$load("37v60"),
    $d2bba54c037d34e8$var$load("cGkFm"),
    $d2bba54c037d34e8$var$load("eF92L"),
    $d2bba54c037d34e8$var$load("jwMHX"),
    $d2bba54c037d34e8$var$load("20wSi"),
    $d2bba54c037d34e8$var$load("bmOOW"),
    $d2bba54c037d34e8$var$load("dDiWc"),
    $d2bba54c037d34e8$var$load("a8R25"),
    $d2bba54c037d34e8$var$load("gaUhx"),
    $d2bba54c037d34e8$var$load("h4Nf7"),
    $d2bba54c037d34e8$var$load("9TOep"),
    $d2bba54c037d34e8$var$load("bncmK"),
    $d2bba54c037d34e8$var$load("6iTkp"),
    $d2bba54c037d34e8$var$load("hhss7"),
    $d2bba54c037d34e8$var$load("aAWLw"),
    $d2bba54c037d34e8$var$load("7EorR"),
    $d2bba54c037d34e8$var$load("6wcNV")
]).then(()=>parcelRequire('iMf0a'));

});

parcelRegister("6wy4M", function(module, exports) {

let $4c002a0469767857$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $4c002a0469767857$var$load("d0ZRF"),
    $4c002a0469767857$var$load("k507P"),
    $4c002a0469767857$var$load("hUbK8"),
    $4c002a0469767857$var$load("b6eef"),
    $4c002a0469767857$var$load("1Gr4q"),
    $4c002a0469767857$var$load("esBxc"),
    $4c002a0469767857$var$load("3pbEq"),
    $4c002a0469767857$var$load("9cVML"),
    $4c002a0469767857$var$load("7G12e"),
    $4c002a0469767857$var$load("4938u"),
    $4c002a0469767857$var$load("7SteV"),
    $4c002a0469767857$var$load("9LJFK"),
    $4c002a0469767857$var$load("d66hN"),
    $4c002a0469767857$var$load("dxA9F"),
    $4c002a0469767857$var$load("bkMxV"),
    $4c002a0469767857$var$load("aRCaA"),
    $4c002a0469767857$var$load("h3Rq9"),
    $4c002a0469767857$var$load("iZR3N"),
    $4c002a0469767857$var$load("jXM1T"),
    $4c002a0469767857$var$load("cvcNg"),
    $4c002a0469767857$var$load("6wr18"),
    $4c002a0469767857$var$load("4N1MY"),
    $4c002a0469767857$var$load("i7NGK"),
    $4c002a0469767857$var$load("kHXvF"),
    $4c002a0469767857$var$load("ea3NB"),
    $4c002a0469767857$var$load("ffEVr"),
    $4c002a0469767857$var$load("l4j2l"),
    $4c002a0469767857$var$load("37v60"),
    $4c002a0469767857$var$load("cGkFm"),
    $4c002a0469767857$var$load("eF92L"),
    $4c002a0469767857$var$load("jwMHX"),
    $4c002a0469767857$var$load("20wSi"),
    $4c002a0469767857$var$load("bmOOW"),
    $4c002a0469767857$var$load("dDiWc"),
    $4c002a0469767857$var$load("gaUhx"),
    $4c002a0469767857$var$load("h4Nf7"),
    $4c002a0469767857$var$load("9TOep"),
    $4c002a0469767857$var$load("bncmK"),
    $4c002a0469767857$var$load("6iTkp"),
    $4c002a0469767857$var$load("hhss7"),
    $4c002a0469767857$var$load("a8R25"),
    $4c002a0469767857$var$load("lnKog"),
    $4c002a0469767857$var$load("aAWLw"),
    $4c002a0469767857$var$load("7EorR"),
    $4c002a0469767857$var$load("i9jMB")
]).then(()=>parcelRequire('estkk'));

});

parcelRegister("1tSr5", function(module, exports) {

let $1142b9b361756cb9$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $1142b9b361756cb9$var$load("d0ZRF"),
    $1142b9b361756cb9$var$load("k507P"),
    $1142b9b361756cb9$var$load("hUbK8"),
    $1142b9b361756cb9$var$load("b6eef"),
    $1142b9b361756cb9$var$load("1Gr4q"),
    $1142b9b361756cb9$var$load("esBxc"),
    $1142b9b361756cb9$var$load("3pbEq"),
    $1142b9b361756cb9$var$load("9cVML"),
    $1142b9b361756cb9$var$load("7G12e"),
    $1142b9b361756cb9$var$load("4938u"),
    $1142b9b361756cb9$var$load("7SteV"),
    $1142b9b361756cb9$var$load("9LJFK"),
    $1142b9b361756cb9$var$load("d66hN"),
    $1142b9b361756cb9$var$load("dxA9F"),
    $1142b9b361756cb9$var$load("bkMxV"),
    $1142b9b361756cb9$var$load("aRCaA"),
    $1142b9b361756cb9$var$load("h3Rq9"),
    $1142b9b361756cb9$var$load("iZR3N"),
    $1142b9b361756cb9$var$load("jXM1T"),
    $1142b9b361756cb9$var$load("cvcNg"),
    $1142b9b361756cb9$var$load("6wr18"),
    $1142b9b361756cb9$var$load("4N1MY"),
    $1142b9b361756cb9$var$load("i7NGK"),
    $1142b9b361756cb9$var$load("kHXvF"),
    $1142b9b361756cb9$var$load("ea3NB"),
    $1142b9b361756cb9$var$load("ffEVr"),
    $1142b9b361756cb9$var$load("l4j2l"),
    $1142b9b361756cb9$var$load("37v60"),
    $1142b9b361756cb9$var$load("cGkFm"),
    $1142b9b361756cb9$var$load("eF92L"),
    $1142b9b361756cb9$var$load("jwMHX"),
    $1142b9b361756cb9$var$load("20wSi"),
    $1142b9b361756cb9$var$load("bmOOW"),
    $1142b9b361756cb9$var$load("dDiWc"),
    $1142b9b361756cb9$var$load("gaUhx"),
    $1142b9b361756cb9$var$load("h4Nf7"),
    $1142b9b361756cb9$var$load("9TOep"),
    $1142b9b361756cb9$var$load("bncmK"),
    $1142b9b361756cb9$var$load("6iTkp"),
    $1142b9b361756cb9$var$load("hhss7"),
    $1142b9b361756cb9$var$load("a8R25"),
    $1142b9b361756cb9$var$load("lnKog"),
    $1142b9b361756cb9$var$load("aAWLw"),
    $1142b9b361756cb9$var$load("7EorR"),
    $1142b9b361756cb9$var$load("aFNXd")
]).then(()=>parcelRequire('cgoGN'));

});

parcelRegister("hIaUw", function(module, exports) {
const $5ff3d548ffdc5eda$export$1ef77878e4e0b972 = (routeName)=>{
    if (routeName?.includes('PAGE')) return 'page';
    if (routeName?.includes('BLOG')) return 'blogpost';
    if (routeName?.includes('SPACE')) return 'space';
    return 'page';
};
module.exports["getContentType"] = $5ff3d548ffdc5eda$export$1ef77878e4e0b972;

});

parcelRegister("dizL5", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $55b20ed34f146485$export$350b371bfb7f5e95 = (loadingComponent)=>(0, $jmjWc.LoadableAfterPaint)({
        __loadable_id__: "UJdch",
        name: "lazyForgeUIExtensionsWithLoader",
        loader: async ()=>(await (parcelRequire("kntSv"))).ForgeUIExtensionsWrapper,
        loading: loadingComponent
    });
const $55b20ed34f146485$export$4cbc6d03d50a8849 = $55b20ed34f146485$export$350b371bfb7f5e95(undefined);
module.exports["lazyForgeUIExtensionsWithLoader"] = $55b20ed34f146485$export$350b371bfb7f5e95;
module.exports["LazyForgeUIExtensions"] = $55b20ed34f146485$export$4cbc6d03d50a8849;

});

parcelRegister("kntSv", function(module, exports) {

let $ed5d21cd821df813$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $ed5d21cd821df813$var$load("a8R25"),
    $ed5d21cd821df813$var$load("lnKog")
]).then(()=>parcelRequire('2mcHd'));

});


//# sourceMappingURL=MainLayout.c800a316.js.map
